import React, { useEffect, useRef, useState } from 'react'
import Constants from '../../../Constants';
import { Link } from 'react-router-dom';
import {getAxiosResponse,deleteAxiosResponse,postAxiosResponse,putAxiosResponse,postAxiosFormDataResponse} from "../../../services/authApiRoutes/APImethods";
import Calendar from "react-calendar";
import CustomProgressBar from "../../global/CustomProgressBar";
import { checkFileSizeInGb, sizeConvertInGb, transformBlankToNull } from "../../../services/Util";
import moment from "moment";
import Select from "react-select";
import { RotatingLines } from 'react-loader-spinner';
import APIUrls from "../../../services/APIUrls";
import {useParams } from "react-router-dom";
import { dateFormat } from "../../../services/Util";
import { confirmAlert } from "react-confirm-alert";
import {ActiveMultiAssigneeIcon, ActiveAssigneeManIcon, FileIcon, ZipfileIcon} from '../../../AppIcons';
import Tooltip from "react-tooltip";
import axios from "axios";
import $ from "jquery";
import {  useTranslation } from 'react-i18next';
import { current } from '@reduxjs/toolkit';
import {useSelector } from "react-redux";
import { handleError } from '../../../services/authApiRoutes/APImethods';
import { compareDates } from '../../../services/Util';
import DateFormat from "../../../pages/DateFormat";
import dateUtil, {DATE_FORMATS} from "../../../services/DateUtil";

export default function ChangeOrderCreateForm(prop) {
    const { t } = useTranslation();
    const translate = t;
    const [languageGroupValues,setLanguageGroupValues] = useState({});
    const accountPermission = useSelector(
        (updateCustomerBootstrapData) => updateCustomerBootstrapData.customer_bootstrap_data,
      ).value;
      const [fileUploadPermission,setFileUploadPermission]=useState(false)
      const [workAssigneeList, setWorkAssigneeList] = useState([]); 
    const [selectedAssignedUser, setSelectedAssignedUser] = useState([]);
    const [changeOrderCreating,setChangeOrderCreating] = useState(false)
    const defaultSelectedTargetLangs = [];
    const [selectedAssignee, setSelectedAssignee] = useState([]);
    const step = "step-1-phase-1";
    const projectStatus = prop.projectDetail.displayName[0].status
    const projectResource = prop.projectDetail.resource.projectResource
    const userGroupId = prop.projectDetail.resource.projectResource.userGroup.id
    if(prop.projectDetail.displayName[0].targetLanguages !== undefined){
        prop.projectDetail.displayName[0].targetLanguages.map((targetLang, index) => {
        defaultSelectedTargetLangs.push({
            label: targetLang.display,
            value: targetLang.code,
        });
        });
    }
    const [languageGroup,setLanguageGroup] = useState([]);
    const [uiFeatures, setUiFeatures] = useState({});
    const [noLanguageIsRemovable,setNoLanguageIsRemovable] = useState(true)
    const [hasNotRemovableLanguage,setHasNotRemoveableLanguage] = useState(false)
    const [notRemovableReason,setNotRemovableReason] = useState('')
    const [validationError,setValidationError] = useState('')
    const chunkSize = Constants.CHUNK_SIZE;
    const [dueDateCalendarExpanded, setDueDateCalendarExpanded] = useState(false);
    
    const param = useParams();
    const [orderName, setOrderName] = useState("");
    const [options, setOptions] = useState({});
    const [buttonDisabled,setButtonDisabled] = useState(false)
    const [selectedStep, setSelectedStep] = useState("");
    const [orderNote, setChangeOrderNote] = useState("");
    const [sourceAsset, setSourceAsset] = useState([]);
    const [documentFileId, setDocumentFileId] = useState(-1);
    const [fileUploadProgress, setFileUploadProgress] = useState(0);
    const [allTargetLanguages,setAllTargetLanguages] = useState([])
    const [targetLanguages, setTargetLanguages] = useState([]);
    const [selectedLanguages, setLanguage] = useState("");
    const [selectedDisplayLangs, setDisplayLangs] = useState([]);
    const [defaultSelectedLangs,setDefaultSelectedLangs] = useState([])
    const [newSelectedLangs, setNewSelectedLangs] = useState([]);
    const [changeOrderId, setChangeOrderId] = useState(-1)
    const [reviewAssigneeList, setReviewAssigneeList] = useState([]);
    const [assigneeListExpanded, setAssigneeListExpanded] = useState(false);
    const [showCalendar, setShowCalendar] = useState(false);
    const [showAssigneeList, setShowAssigneeList] = useState(false);
    const [showProgress,setShowProgress] = useState(false)
    const [updatedWorkflow,setUpdatedWorkFlow] = useState([])
    const [currentChunkIndex, setCurrentChunkIndex] = useState(null);
    const [charsLeft, setCharsLeft] = useState(1000);
    const [charsLeftName, setCharsLeftName] = useState(50);
    const [deletedFiles,setDeletedFiles] = useState([]);
    const [payload,setPayload] = useState({});
    const [selectedFiles,setSelectedFiles] = useState([]);
    const [assigneeWorkFlowData,setAssigneeWorkFlowData] = useState({})
    const [workflowIndex,setWorkflowIndex] = useState(-1)
    const [stepNumber,setStepNumber] = useState(-1)
    const [phaseNumber,setPhaseNumber] = useState(-1)
    const [removedLangs,setRemovedLangs] = useState([])
    const [languageDeliverableStatus,setLanguageDeliverableStatus] = useState([])
    const [leastOneLangApproved,setLeastOneLangApproved] = useState(false)
    const [workflow, setworkflowData] = useState([]);
    const [newChangeOrderId,setNewChangeOrderId] = useState('')
    const [autoBid,setAutoBid] = useState(false)
    const [currentFileIndex, setCurrentFileIndex] = useState(null);
    const [nextAriaLabel,setNextAriaLabel] = useState('Go to next month')
    const [prevAriaLabel,setPrevAriaLabel] = useState('Go to previous month')
    const [next2AriaLabel,setNext2AriaLabel] = useState('Go to next year')
    const [prev2AriaLabel,setPrev2AriaLabel] = useState('Go to previous year')
    const [viewType,setViewType] = useState('month')
    const [actualRemovedLang,setActualRemovedLang] = useState([])
    const getAssigneesForWorkFlow = () =>{
        getAxiosResponse(APIUrls.REVIEWABLE_ASSIGNEES(prop.projectDetail.resource.projectResource.userGroup.id))
        .then((res) => {
        if (res.data.code === 200) {
            setReviewAssigneeList(res.data.data);
        }
        }).catch((err) => {
            console.error(err);
        });

        getAxiosResponse(APIUrls.WORK_ASSIGNEES(prop.projectDetail.resource.projectResource.userGroup.id))
        .then((res) => {
        if (res.data.code === 200) {
            var users = res.data.data
            setWorkAssigneeList(users)
        }
        }).catch((err) => {
        console.error(err);
        });

    }

    useEffect(() => {
        const assigneeList = [];
        getAssigneesForWorkFlow()
        getAxiosResponse(APIUrls.GET_UI_FEATURES(param.id)).then((res) => {
            setUiFeatures(res.data.data);
          }).catch(err=>{
            console.error(err)
          })
        getAxiosResponse(APIUrls.DELIVERABLE_LANGUAGE_STATUS(param.id))
        .then((res) => {
        if (res.data.code === 200) {
            setLanguageDeliverableStatus(res.data.data);
            res.data.data.forEach((data)=>{
                if(data.resource.languageStatus === "APPROVED"){
                    setLeastOneLangApproved(true)
                }
            })
        }
        }).catch((err) => {
            console.error(err);
        });

        getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA).then((res) => {
            setOptions(res.data.data);
          });

        getAxiosResponse(
            APIUrls.EXISTING_PROJECT_WORKFLOW(param.id, getWorkflowStatusForQuery())
          )
            .then((res) => {
              if (res.data !== "") {
                var resData = res.data.data
                
                res.data.data.map((workflow,index)=>{
                     var lang = {code: workflow.displayName[0].code, display: workflow.displayName[0].displayName};
                    if (workflow.resource.status !== 'CANCELLED') {
                        if (workflow.resource.currentStepId === '')	{
                            setHasNotRemoveableLanguage(true)
                            lang.removable = false;
                            setNotRemovableReason(Constants.REMOVE_LANG_TOOL_TIP_CREATE_CHANGE_ORDER)
                           
                        }
                        else{
                            setNoLanguageIsRemovable(false)
                            lang.removable = true;
                        }
                        
                    }
                })
                setworkflowData(resData);
              }
            })
            .catch((err) => {
              handleError(err);
            });
        
        
        $('.firstBtnFocus').trigger('focus')
        getTargetLanguages();
        getSourceAsset();
    }, []);
    const showCustomNavigationLabel = (date, label, locale, view) =>{
        return <span aria-label={` date: ${dateFormat(date,'MMMM - YYYY')}`}>{dateFormat(date,'MMMM - YYYY')}</span>
      }
    const viewChange = (action, activeStartDate, value, view) =>{
        setViewType(view)
        if(view === 'month'){
          setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_MONTH)
          setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_MONTH)
          setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_YEAR)
          setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_YEAR)
        }
        if(view === 'year'){
          setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_YEAR)
          setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_YEAR)
          setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_DECADE)
          setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_DECADE)
        }
        if(view === 'decade'){
            $('.react-calendar__tile--hasActive').addClass("decade-active");
            $('.react-calendar__tile--hasActive').focus()
          setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_DECADE)
          setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_DECADE)
          setNext2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_CENTURY)
          setPrev2AriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_CENTURY)
        }
        if(view === 'century'){
            $('.react-calendar__tile--hasActive').addClass("decade-active");
            $('.react-calendar__tile--hasActive').focus()
          setNextAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.NEXT_CENTURY)
          setPrevAriaLabel(Constants.CALENDAR_NAVIGATION_ARIA_LABEL.PREV_CENTURY)
        }
      }
    const isAllowedToChangeSource = () =>{
        return !leastOneLangApproved && uiFeatures.CHANGE_SOURCE_MATERIAL
    }
    const getTargetLanguages = ()=>{
        var langArray = [];
        var defaultSelectedTargetLangs = [];
        prop.projectDetail.displayName[0].targetLanguages.map((targetLang, index) => {
            defaultSelectedTargetLangs.push({label: targetLang.display,value: targetLang.code,language : targetLang.language});
        }
        );
        if (defaultSelectedTargetLangs.length !== 0) {
            setDefaultSelectedLangs(defaultSelectedTargetLangs)
            setDisplayLangs(defaultSelectedTargetLangs);
        }
        getAxiosResponse(APIUrls.TARGET_LANGUAGE)
        .then((res) => {
        if (res.data !== "") {
            res.data.data.map((langs) => {
                if(langs.code !== prop.projectDetail.displayName[0].sourceLanguage.code){
                    langArray.push({label: langs.display,value: langs.code,language : langs.language});
                }
            });
            const results = langArray.filter(({ value: id1 }) =>!defaultSelectedTargetLangs.some(({ value: id2 }) => id2 === id1));
            results.unshift({label: 'Select All',value: 'all',language : ''})
            var sourceRemoved = results.filter((val)=>{
                return val.value !== prop.projectDetail.displayName[0].sourceLanguage.code
            })
            setTargetLanguages(sourceRemoved);
            setAllTargetLanguages(langArray)

        }
        }).catch((err) => {
            console.error(err);
        });
    };
    useEffect(()=>{
        getAxiosResponse(APIUrls.GET_CUSTOMER_LANGUAGE_GROUP)
        .then((response)=>{
          const data = response.data.data
          if(data){
              let values = {};
              let langGrp = []
              data.forEach((o)=>{
                  values[o?.resource?.name] = o.displayName[0].map((o)=>({label:o.display,value:o.code,language:o.name}));
                  langGrp.unshift({label:o?.resource?.name,value:o.displayName[0].map((o)=>({label:o.display,value:o.code,language:o.name})),language:""})
              });
              setLanguageGroupValues(values);
              setLanguageGroup(langGrp);
              let targlang = targetLanguages;
              langGrp.forEach((o)=>{
                    targlang.unshift(o);
                })
                setTargetLanguages(targlang);
          }
        }).catch((err)=>{
          console.error(err);
        })
    },[allTargetLanguages])
    const getSourceAsset=()=>{
        getAxiosResponse(APIUrls.GET_SOURCE_ASSETS(param.id))
        .then((res) => {
        if (res.data !== "") {
            setSourceAsset(res.data.data.result);
        }
        }).catch((err) => {
        console.error(err);
        });
    };
    useEffect(()=>{
		$.each($('.react-calendar__tile'), function( index, value ) {
		  $(value).attr('aria-label', value.children[0].ariaLabel);
		});
	});

    $(document).mouseup(function(e) {
        var bannerCont = $('.step-cal');
        if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        setDueDateCalendarExpanded(false);
        setShowCalendar(false);
        setTimeout(() => {
            $('.step-cal.focusAdd').removeClass('focusAdd');
        }, 100);
        }
    });

    $(document).mouseup(function(e) {
        setTimeout(() => {
            var bannerCont = $('.assignHidepopup');
            if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
              setAssigneeListExpanded(false);
              setShowAssigneeList(false);
            }
        }, 100);
    });

    $(document).on("click keydown",".step-cal",function(e) {
        if (e.type==="click") {
          $(this).addClass('focusAdd');
        } else 
        if (e.key===Constants.ESCAPE) {
          setDueDateCalendarExpanded(false);
          setShowCalendar(false);
          $(this).trigger('focus');
          $(this).removeClass('focusAdd');
        }
    });
    const getMinDate = (step,phase,phaseNum,stepNum, workflowGroup,wfgIndex) =>{
        if(phaseNum === 1 && stepNum === 1){
            return new Date(dateUtil.getDateTimestamp(phase.dueDate))
        }
        else{
            if(phaseNum === 1){
                let prevStepPhasescount = workflowGroup.steps[stepNum-2].phases.length;
                let prevPhaseDate =  new Date(dateUtil.getDateTimestamp(workflowGroup.steps[stepNum-2].phases[prevStepPhasescount-1].dueDate))
                return prevPhaseDate
            }else{
                return new Date(dateUtil.getDateTimestamp(workflowGroup.steps[stepNum-1].phases[phaseNum - 2].dueDate))
            }
        }

    }
    const changeDate = (value,event,phaseNum,stepNum,workflowGroup,wfgIndex) => {
        setValidationError('')
        var copyUpdatedWorkflow = structuredClone(updatedWorkflow)
         let dueDate = dateUtil.getDateTimestamp(value);
        copyUpdatedWorkflow[wfgIndex].steps.forEach((step,stepIndex)=>{
            if(stepIndex >= stepNum-1){
                copyUpdatedWorkflow[wfgIndex].steps[stepIndex].phases.map((phase,phaseIndex)=>{
                    if((phaseIndex >= phaseNum-1) || (stepIndex > stepNum-1)){
                        var dateDiff = compareDates(copyUpdatedWorkflow[wfgIndex].steps[stepIndex].phases[phaseIndex].dueDate,dueDate)
                       if(dateDiff < 0 || (stepNum === stepIndex+1 && phaseIndex+1 === phaseNum)){
                        copyUpdatedWorkflow[wfgIndex].steps[stepIndex].phases[phaseIndex].dueDate = dueDate
                       }
                        
                    }
                })
            }
        })
        var copyNewLangSelected = structuredClone(newSelectedLangs)
        copyNewLangSelected[wfgIndex].resource = copyUpdatedWorkflow[wfgIndex]
         setNewSelectedLangs(copyNewLangSelected)
        setUpdatedWorkFlow(copyUpdatedWorkflow);
        if (workflowGroup.templateType.code === "builtin_single_step" || workflowGroup.templateType.code === "custom") {
          $(event.target).parents(".popover-body").siblings("span.due-date").html(moment(value).format("DD/MM"));
        }
        setDueDateCalendarExpanded(false);
        setShowCalendar(false);
        setTimeout(() => {
          $('.step-cal.focusAdd').trigger('focus');
          $('.step-cal.focusAdd').removeClass('focusAdd');
        }, 100);
    };
    
    const onValueChange=(event,element,phase,phaseNum,stepNum,workflowGroup,wfgIndex,multiAssignee) => {
        setValidationError('')
        var copyLangWorkFlow = structuredClone(updatedWorkflow)
        var workflowPhase = copyLangWorkFlow[wfgIndex].steps[stepNum -1].phases[phaseNum-1]
        var phaseAsigneeUsers = workflowPhase.assigneeUsers
        setWorkflowIndex(wfgIndex)
        setStepNumber(stepNum)
        setPhaseNumber(phaseNum)

            var matchedUser = reviewAssigneeList.filter((element)=>
            {
                return phaseAsigneeUsers.some((id2) => id2.userId === element.customerUser.userId)
            })
                setSelectedAssignee(matchedUser)
        
        if(event.code === 'Enter' || event.type === "change"){
            if(multiAssignee){
                if(phaseAsigneeUsers.some((id2) => id2.userId === element.customerUser.userId)){
                    var filteredUsers = phaseAsigneeUsers.filter((usr)=>{
                    return usr.userId !== element.customerUser.userId
                    })
                    var matchedFilteredUser = reviewAssigneeList.filter((element)=>{
                        return filteredUsers.some((id2) => id2.userId === element.customerUser.userId)
                    })
                    setSelectedAssignee(matchedFilteredUser)
                }else{
                     setSelectedAssignee((current)=>[...current,element])
                }
                    var workflowData = {
                        'element':element,
                        'phaseNum':phaseNum,
                        'stepNum':stepNum,
                        'wfgIndex':wfgIndex,
                        'multiAssignee':multiAssignee
                    }
                    setAssigneeWorkFlowData(workflowData)
            }else{ 
            const pf = structuredClone(updatedWorkflow[wfgIndex]);
            const pfSteps = [...pf.steps];
            let phPhase;
            let phStep;
            pfSteps.map((pfstep, stepIndex) => {
            phStep = { ...pfstep };
            if (stepIndex === stepNum - 1) {
                const pfPhases = [...pfstep.phases];
                pfPhases.map((pfphase, index) => {
                if (index === phaseNum - 1) {
                    phPhase = { ...pfphase };

                    let customerUser = {
                    random: null,
                    enabled: element.customerUser.enabled,
                    wrongPasswordAttempt: null,
                    userId: element.customerUser.userId,
                    lastAccessedDate: null,
                    locked: false,
                    originalEmail: null,
                    roleSet: {
                        roleTypes: element.customerUser.roleSet.roleTypes,
                        roleTypeList: element.customerUser.roleSet.roleTypeList,
                    },
                    requestedEmail: null,
                    samlEnabled: element.customerUser.samlEnabled,
                    createdDate: null,
                    language: null,
                    timeZone: null,
                    locale: null,
                    password: null,
                    email: element.customerUser.email,
                    customer: null,
                    lastName: element.customerUser.lastName,
                    roleTypes: element.customerUser.roleSet.roleTypes,
                    userGroupMembers: null,
                    activeUserGroup: null,
                    title: null,
                    firstName: element.customerUser.firstName,
                    azureSsoEnabled: element.customerUser.azureSsoEnabled,
                    sfdcUserId: element.customerUser.sfdcUserId,
                    };
                    phPhase.assigneeUsers = [customerUser];
                    pfPhases[index] = phPhase;
                }
                });
                phStep.phases = pfPhases;
            }
            pfSteps[stepIndex] = phStep;
            });
            pf.steps = pfSteps;
            let updatedProjectWfs = {...updatedWorkflow};
            updatedProjectWfs = pf;
            const copyWorkflow = [...updatedWorkflow];
            copyWorkflow[wfgIndex] = updatedProjectWfs;
            var copyNewSelectedLangs = structuredClone(newSelectedLangs)
            copyNewSelectedLangs[wfgIndex].resource = copyWorkflow[wfgIndex]
            setNewSelectedLangs(copyNewSelectedLangs)
            setUpdatedWorkFlow(copyWorkflow);
            let popoverBody = $(event.target).parents(".popover-body");
                if (popoverBody.hasClass("show-assignee-dropdown")) {
                setAssigneeListExpanded(false);
                }
            setShowAssigneeList(false);
            }
        }
        else if(event.code === 'Escape'){
            setShowAssigneeList(false)
        }
    };
    const EditAssigneeComponent = (prop) =>{
        const langIndex = prop.langIndex;
        const stepIndex = prop.stepIndex;
        const phaseIndex = prop.phaseIndex;
        const phase = prop.phase;
        const step = prop.step
        const newlang = prop.newlang
        var languageReviers = []
        var otherUsers = []
        reviewAssigneeList.forEach((element,AssigneeIndex) =>{
            if(element.reviewLanguages.includes(newlang.resource.language)){
                languageReviers.push(element)
            }else{
                otherUsers.push(element)
            }
        })
        return(
            <div className="group-radio-list">
                 <strong>Language Reviewers</strong>
            {languageReviers.map((element,AssigneeIndex) => {  
                    return(<div className="radio-form-check" key={AssigneeIndex}>
                       
                    <input aria-label={element?.customerUser?.firstName +" " +element?.customerUser?.lastName}
                    type="checkbox" className="form-check-input"
                    name={element?.customerUser?.firstName + " " + element?.customerUser?.lastName}
                    id={`${langIndex +"-" +stepIndex +"-" +phaseIndex}-`+element?.customerUser?.userId}
                    value={element?.customerUser?.firstName +" " +element?.customerUser?.lastName}
                    checked={phase.allowMultiAssignee ?
                        phase.assigneeUsers.length > 0 ?
                        phase.assigneeUsers.some(usr => {
                            if (element.customerUser.userId === usr.userId) {
                                return true;
                            }
                            return false;
                            }) : ''
                        : phase.assigneeUsers[0]?.userId === element?.customerUser.userId}
                    defaultChecked={true}    
                    onKeyDown={(event) => onValueChange(event,element,phase,phase.phaseNumber,step.stepNumber,newlang.resource,langIndex,phase.allowMultiAssignee)}  
                    onChange={(event) => onValueChange(event,element,phase,phase.phaseNumber,step.stepNumber,newlang.resource,langIndex,phase.allowMultiAssignee)}
                    />
                    <label
                    className="form-check-label"
                    htmlFor={`${langIndex +"-" +stepIndex +"-" +phaseIndex}-`+element?.customerUser?.userId}>
                    {element?.customerUser?.firstName +" " +element?.customerUser?.lastName}{' ('}
                    {element?.customerUser.roleSet.roleTypes.map((roles,index)=>{
                        if(element?.customerUser.roleSet.roleTypes.length > index +1){
                            return `${roles.displayName} , ` 
                        }else{
                            return roles.displayName
                        }
                    })}{') '}
                    </label>
                </div>)})}
                <strong>Other Users</strong>
                { otherUsers.map((element,AssigneeIndex)=>{ 
                    return(<div className="radio-form-check" key={AssigneeIndex}>
                        
                    <input aria-label={element?.customerUser?.firstName +" " +element?.customerUser?.lastName}
                    type="checkbox" className="form-check-input"
                    name={element?.customerUser?.firstName + " " + element?.customerUser?.lastName}
                    id={`${langIndex +"-" +stepIndex +"-" +phaseIndex}-`+element?.customerUser?.userId}
                    value={element?.customerUser?.firstName +" " +element?.customerUser?.lastName}
                    checked={phase.allowMultiAssignee ?
                        phase.assigneeUsers.length > 0 ?
                        phase.assigneeUsers.some(usr => {
                            if (element.customerUser.userId === usr.userId) {
                                return true;
                            }
                            return false;
                            }) : ''
                        : phase.assigneeUsers[0]?.userId === element?.customerUser.userId}
                    defaultChecked={true}    
                    onKeyDown={(event) => onValueChange(event,element,phase,phase.phaseNumber,step.stepNumber,newlang.resource,langIndex,phase.allowMultiAssignee)}  
                    onChange={(event) => onValueChange(event,element,phase,phase.phaseNumber,step.stepNumber,newlang.resource,langIndex,phase.allowMultiAssignee)}
                    />
                    <label
                    className="form-check-label"
                    htmlFor={`${langIndex +"-" +stepIndex +"-" +phaseIndex}-`+element?.customerUser?.userId}>
                    {element?.customerUser?.firstName +" " +element?.customerUser?.lastName}{' ('}
                    {element?.customerUser.roleSet.roleTypes.map((roles,index)=>{
                        if(element?.customerUser.roleSet.roleTypes.length > index +1){
                            return `${roles.displayName} , ` 
                        }else{
                            return roles.displayName
                        }
                    })}{') '}
                    </label>
                </div>)})
                  
                 
        }
        </div>)
    }
    useEffect(()=>{
        var phaseNum= Number(assigneeWorkFlowData.phaseNum)
        var stepNum = Number(assigneeWorkFlowData.stepNum)
        var wfgIndex = assigneeWorkFlowData.wfgIndex
        if(updatedWorkflow.length !== 0 && updatedWorkflow[wfgIndex]){
            const pf = { ...updatedWorkflow[wfgIndex] };
            const pfSteps = [...pf.steps];
            let phPhase;
            let phStep;
            var customerUser = []
            pfSteps.map((pfstep, stepIndex) => {
            phStep = { ...pfstep };
            if (stepIndex === stepNum - 1) {
                const pfPhases = [...pfstep.phases];
                pfPhases.map((pfphase, index) => {
                    if (index === phaseNum - 1) {
                        phPhase = { ...pfphase };
                        selectedAssignee.forEach((element)=>{
                            customerUser.push({
                            random: null,
                            enabled: element.customerUser.enabled,
                            wrongPasswordAttempt: null,
                            userId: element.customerUser.userId,
                            lastAccessedDate: null,
                            locked: false,
                            originalEmail: null,
                            roleSet: {
                                roleTypes: element.customerUser.roleSet.roleTypes,
                                roleTypeList: element.customerUser.roleSet.roleTypeList,
                            },
                            requestedEmail: null,
                            samlEnabled: element.customerUser.samlEnabled,
                            createdDate: null,
                            language: null,
                            timeZone: null,
                            locale: null,
                            password: null,
                            email: element.customerUser.email,
                            customer: null,
                            lastName: element.customerUser.lastName,
                            roleTypes: element.customerUser.roleSet.roleTypes,
                            userGroupMembers: null,
                            activeUserGroup: null,
                            title: null,
                            firstName: element.customerUser.firstName,
                            azureSsoEnabled: element.customerUser.azureSsoEnabled,
                            sfdcUserId: element.customerUser.sfdcUserId,
                            });
                        })
                        phPhase.assigneeUsers = customerUser;
                        pfPhases[index] = phPhase;
                    }
                });
                phStep.phases = pfPhases;
            }
            pfSteps[stepIndex] = phStep;
            });
            pf.steps = pfSteps;
            let updatedProjectWfs = {...updatedWorkflow};
            updatedProjectWfs = pf;
            const copyWorkflow = [...updatedWorkflow];
            copyWorkflow[wfgIndex] = updatedProjectWfs;
            var copyNewSelectedLangs = structuredClone(newSelectedLangs)
            copyNewSelectedLangs[wfgIndex].resource = copyWorkflow[wfgIndex]
            setNewSelectedLangs(copyNewSelectedLangs)
            setUpdatedWorkFlow(copyWorkflow);
        }
    },[assigneeWorkFlowData])
    const selectAssignee = (e, event,allowMultiAssignee) => {
        if (event.type === "click" ||
        (!($(event.target).closest('.step-assignee').has($(document.activeElement)).length > 0) && event.key === Constants.ENTER) ||
        ($('.assignee-dropdown.popover-body').hasClass('show-assignee-dropdown') && event.key === Constants.ESCAPE)) {
        setSelectedStep(event);
        assigneeListExpanded ? setAssigneeListExpanded(false) : setAssigneeListExpanded(true);
        showAssigneeList === e ? setShowAssigneeList('') : setShowAssigneeList(e);
        $(event.target).closest('.step-assignee').trigger('focus');
        }
        if (event.key === Constants.TAB) {
        if ($(event.target).closest('.group-radio-list div').is(':last-child') &&
            event.key === Constants.TAB && !event.shiftKey) {
                event.preventDefault();
                $(event.target).closest('.group-radio-list').find('div:first-child input').trigger('focus');
        } else if ($(event.target).closest('.group-radio-list div').is(':first-child') &&
            event.key === Constants.TAB && event.shiftKey) {
                event.preventDefault();
                $(event.target).closest('.group-radio-list').find('div:last-child input').trigger('focus');
        } 
        }
    };
    const clearValue = (e) => {
        e.target.value = null;
    };
    
    const confirmSubmit = () => {
        setTimeout(() => {
            $("#deleteNo").trigger("focus");
            $("#react-confirm-alert").attr( { role:"dialog", 'aria-modal':"true", 'aria-label':"Submit Change Order" } );
          }, 500);
        confirmAlert({
            title: 'Submit Change Order',
            message: getMessage(),
            buttons: [
                {
                    label: "Yes",
                    id: "deleteYes",
                    onClick: () =>createChangeOrder(),
                    onKeyDown: (e) => {
                        if (e.key === "Tab") {
                          if (e.shiftKey === true) {
                            e.preventDefault();
                            $("#deleteNo").trigger("focus");
                          }
                        }
                      },
                 },
                {
                    label: "No",
                    id: "deleteNo",
                    onClick: () => {
                        $('.changeOrder').trigger('focus');
                    },
                    onKeyDown: (e) => {
                        if (e.key === "Tab") {
                          if (e.shiftKey === false) {
                            e.preventDefault();
                            $("#deleteYes").trigger("focus");
                          }
                        }
                        if (e.key === Constants.ESCAPE) {
                          $('.changeOrder').trigger('focus');
                        }
                  },
                },
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            // keyCodeForClose: [8, 32],
            // willUnmount: () => {},
            // afterClose: () => {},
            // onClickOutside: () => {},
            // onKeypress: () => {},
            // onKeypressEscape: () => {},
            overlayClassName: "delete_overlay",
        });
    };

    const deleteSourceFile = (source)=>{
        setDeletedFiles((ids)=>[...ids,source]);
        var divLength2 = $('.source-file-item').length;
        if (divLength2 === 1) {
          $('.firstBtnFocus').trigger('focus'); 
        }
        const selectedElement = $(document.activeElement).closest(".wrap-source-file-item");
        if(!$(document.activeElement).closest('.source-file-item:last-child').length &&
          selectedElement.children().length > 1){
            $(document.activeElement).closest('.source-file-item').next().find('button').trigger('focus');
        } else if($(document.activeElement).closest('.source-file-item:last-child')){
            $(document.activeElement).closest('.source-file-item').prev().find('button').trigger('focus');
        }
        $(`#source-${source.id}`).html(`<div className='source-file-item'><span>${Constants.CHANGE_ORDER_SOURCE_FILE_REMOVED}</span></div>`);
        // $(`#source-${source.id}`).remove();
     };
     const fileSelection=(e) =>{
        if (e.target) {
            var multipleFiles = Array.from(e.target.files);
            setSelectedFiles(multipleFiles);
            const files = multipleFiles;
            files.forEach((file)=>{
                if(checkFileSizeInGb(file,accountPermission.maxFileUploadSizeGb)){
                    setFileUploadPermission(true)
                  }else{
                    setFileUploadPermission(false)
                  }
            })
      
        }
    };
    const addAnother = (e)=>{
        if (e.target) {
            setSelectedFiles((current)=>[...current,e.target.files[0]]);
        }
    }
    useEffect(() => {
        if (currentFileIndex !== null) {
            setCurrentChunkIndex(0);
        }
      }, [currentFileIndex]);
    useEffect(() => {
        if (currentChunkIndex !== null) {
            readAndUploadCurrentChunk();
        }
    }, [currentChunkIndex]);

    const readAndUploadCurrentChunk=() => {
        const file = selectedFiles[currentFileIndex];
        if (file) {
            const reader = new FileReader();
            const from = currentChunkIndex * chunkSize;
            const to = from + chunkSize;
            const blob = file.slice(from, to);
            reader.onload = (e) => uploadChunk(e);
            reader.readAsDataURL(blob);
        }else{
            uploadChunk(null);
        }
    };
    
    const uploadChunk=(readerEvent)=>{
        const file = selectedFiles[currentFileIndex]
        const data = readerEvent ? readerEvent.target.result : {};
        const params = getParams();
        const headers = {
        "Content-Type": "application/octet-stream",
        "CSRF-Token": localStorage.getItem("csrfToken"),
        };
        const urlPart = file ? APIUrls.CHANGE_ORDER_FILE_UPLOAD_SUBMIT : APIUrls.CHANGE_ORDER_FILE_UPLOAD_SUBMIT.replace("/upload","");
        const url =`${process.env.REACT_APP_BACKEND_SERVER}${urlPart}?`+params.toString();
        axios.post(url, data, { headers })
        .then((response) => {
            if(file){
                const filesize = file.size;
                const chunks = Math.ceil(filesize / chunkSize) - 1;
                const isLastChunk = currentChunkIndex === chunks;
                if (isLastChunk) {
                    setCurrentChunkIndex(null);
                    setFileUploadProgress(100);
                    if(selectedFiles.length === currentFileIndex+1){
                        updateChangeOrder(param.id,payload);
                        setTimeout(() => {
                            setShowCreateChangeOrder(false);
                            prop.refreshChangeOrderList()
                        }, 1000);
                    }else{
                        setShowProgress(false);
                        uploadNewSourceFiles('',currentFileIndex+1)
                    }
                     
                } else {
                    const chunks = Math.ceil(filesize / chunkSize);
                    setFileUploadProgress(Math.round((currentChunkIndex / chunks) * 100));
                    setCurrentChunkIndex(currentChunkIndex + 1);
                }
            }else {
                setCurrentChunkIndex(null);
                setFileUploadProgress(100);
                setShowProgress(false);
                updateChangeOrder(param.id,payload);
                setTimeout(() => {
                    setShowCreateChangeOrder(false);
                }, 1000);
            }
        });
    };

    const getParams=()=>{
        const file = selectedFiles[currentFileIndex];
        const params = new URLSearchParams();
        if(file){
            params.set("name", file.name);
            params.set("size", file.size);
            params.set("currentChunkIndex", currentChunkIndex);
            params.set("totalChunks", Math.ceil(file.size / chunkSize));
        }
        params.set("docFileId", documentFileId);
        params.set("ignoreValidations", -1);
        params.set("pId", param.id);
        params.set("coId", changeOrderId);
        return params;
    };

    const openCalendar = (calendarState, e) => {
        if (!($(e.target).closest('.dashCalendar').has($(document.activeElement)).length > 0) && e.type==="click") {
          dueDateCalendarExpanded ? setDueDateCalendarExpanded(false) : setDueDateCalendarExpanded(true);
           showCalendar === calendarState ? setShowCalendar('') : setShowCalendar(calendarState);
          $('.popover-body-calendar').removeClass('hide');
          $('.focusAdd').trigger('focus'); 
        }
    };

    const handleAreaChange = (value)=>{
        setChangeOrderNote(value);
        setCharsLeft(1000-value.length);
    };
    const handleOrderNameChange = (value) =>{
        setOrderName(value);
        setCharsLeftName(50-value.length)
    }
    
    const setPhaseType = (step, phase) => {
        if (phase.phaseType.code === "review") {
            return <strong>{phase.name !== "" ? phase.name : translate("other_integrations_project_creation.final_review_due")}</strong>;
        }
        return <strong>{phase.name !== "" ? phase.name : phase.phaseType.display}</strong>;
    };

    const handleLanguageChange = (event) => {
        setButtonDisabled(true)
        var result;
        var selectedLang = event.value;
        var allLangcodes = ''
        var allLangaugeCodes = []
        if(selectedLang === 'all'){
            var removeFirstOption = allTargetLanguages
            setRemovedLangs([])
            setDisplayLangs(removeFirstOption)
            removeFirstOption.forEach((lang,index)=>{
                setLanguage((current) => [...current, lang.value]);
            })
            targetLanguages.map((allTarget,index)=>{
                if(allTarget.value !== 'all'){
                    if(allTarget.value.length && allTarget.value.length > 0 && typeof allTarget.value !== 'string'){
                        allTarget.value.map((groupLang,groupIndex)=>{
                            allLangaugeCodes.push(groupLang.language)
                            if(index === 0){
                                allLangcodes = `?language=${groupLang.value}`
                            }else{
                                allLangcodes +=`&language=${groupLang.value}`
                            }
                        })
                    }else{
                        allLangaugeCodes.push(allTarget.language)
                        if(index === 1){
                            allLangcodes = `?language=${allTarget.value}`
                        }else{
                            allLangcodes +=`&language=${allTarget.value}`
                        }
                    }
                }
            })
             workflowLangAdded(allLangcodes,allLangaugeCodes)
            setTargetLanguages([])
        }else if(typeof selectedLang !== 'string' && selectedLang.length > 0){

                var lang_codes = selectedLang.map((lang)=> lang.value)

                const filteredArray = selectedDisplayLangs.filter((item) =>
                    !lang_codes.includes(item.value)
                );
                const filteredRemovedLang = removedLangs.filter((langs)=>
                    !lang_codes.includes(langs.value)
                );
               
                var lanstr= ''
                selectedLang.forEach((lang,index)=>{
                    if(index === 0){
                        lanstr += `?language=${lang.value}`
                    }else{
                        lanstr += `&language=${lang.value}`
                    }
                })
                workflowLangAdded(lanstr,lang_codes)
                let result = [...selectedLang, ...filteredArray];
                var shortedLangs = result.sort((a,b) => a-b);
                setDisplayLangs(shortedLangs)
                setRemovedLangs(filteredRemovedLang)
                setTargetLanguages((current) =>
                current.filter((langs) => langs.value !== selectedLang)
                );
        }
        else{
            result = targetLanguages.find(({ value }) => value == selectedLang);
            setDisplayLangs((current) => [...current, result]);
            var filteredRemovedLang = removedLangs.filter((langs)=>{
                return langs.value !== selectedLang
            })
            var filteredActualRemovedLang = actualRemovedLang.filter((langs)=>{
                return langs.value !== selectedLang
            })
            setRemovedLangs(filteredRemovedLang)
            setActualRemovedLang(filteredActualRemovedLang)
            var actualSelected = defaultSelectedLangs.filter((lang) => {
                return lang.value === selectedLang
            });
            if(actualSelected.length === 0){
                workflowLangAdded(`?language=${event.value}`,event.language);
            }else{
                setButtonDisabled(false)
            }
            setTargetLanguages((current) =>
            current.filter((langs) => langs.value !== selectedLang)
            );
            setLanguage((current) => [...current, event.code]);
        }

    };
   useEffect(()=>{
    var copyTargetLangs = structuredClone(targetLanguages.slice(1))
    const strAscending = [...copyTargetLangs].sort((a, b) =>
    a.label > b.label ? 1 : -1,
    );
    strAscending.unshift({label: 'Select All',value: 'all',language : ''})
    setTargetLanguages(strAscending)
   },[selectedDisplayLangs])
        
    

    const removeItem = (selected) => {
        workflowRemoved(selected)
        var actualRemovedLang = ''
        setValidationError('')
        prop.projectDetail.displayName[0].targetLanguages.map((targetLang, index) => {
            if(selected.value === targetLang.code){
                actualRemovedLang = selected
            }
        })
        if(actualRemovedLang !== ''){
            setActualRemovedLang((current)=>[...current,actualRemovedLang])
        }
        var result = removedLangs.find(( langs ) => langs.value === selected.value);
        if(result === undefined){
            setRemovedLangs((current)=>[...current,selected])
        }
        var value = selected.value;
        setDisplayLangs((current) =>
        current.filter(
            (selectedDisplayLangs) => selectedDisplayLangs.value !== value
        )
        );
        setNewSelectedLangs((current) =>
            current.filter(
                (newSelectedLangs) => newSelectedLangs.displayName[0].code !== value
            )
        );
        setTargetLanguages((current) => [...current, selected]);
        // setListInOrder()
        const found = targetLanguages.some(el => el.value === 'all');
        
        if(!found && targetLanguages.length > 1){
            targetLanguages.unshift({label: 'Select All',value: 'all',language : ''})
        }
        const selectedElement = $(document.activeElement).closest(".multiselect-output");
        if($(document.activeElement).is(':last-child') &&
          selectedElement.children().length > 1){
            selectedElement.find('button:nth-last-child(2)').trigger('focus');
        } else if($(document.activeElement).is(':last-child')){
          $(document.activeElement).closest(".wrap-dropdown").find('.global-dropdown-block input:first-of-type').trigger('focus');
        }
    };
    
    const createChangeOrder = () => {
        setChangeOrderCreating(true)
        if(orderName){
            const data = {
                newTargetLanguages: selectedDisplayLangs.map(lang=>lang.language),
                name: orderName,
                description: orderNote,
                workflows: updatedWorkflow,
                projectAssetsToRemove: deletedFiles.map((file)=>{return {id:file.id}})
            };
            if(autoBid){
                data.autoAccept = autoBid
            }
            let formData = transformBlankToNull(data)
            formData = dateUtil.dateTimestampObjectTransformation(formData, ["dueDate"]);
            postAxiosResponse(APIUrls.CHANGE_ORDER_BY_PROJECT(param.id),formData)
            .then((res) => {
                if(res.data && res.data.data.success !== false){
                    let response = res.data.data;
                    response.newTargetLanguages = selectedDisplayLangs.map(lang=>lang.language);
                    response.workflows = updatedWorkflow;
                    response.status = "requested";
                    let finalPayload = transformBlankToNull(response);
                    setPayload(finalPayload);
                    setChangeOrderId(finalPayload.id);
                    if(selectedFiles.length === 0){
                        updateChangeOrder(param.id,finalPayload);
                    }
                    else{
                        setShowProgress(true);
                        uploadNewSourceFiles(finalPayload,0);
                    }
                }else if(res.data.data.errors){
                    var errors = res.data.data.errors
                    // markWorkflowGroupsWithError(errors)
                    setValidationError(errors)
                }
                setChangeOrderCreating(false)
            })
            .catch((err) => {
                console.error(err);
            });
        }
    };
    const getWorkflowStatusForQuery = () => {
        if (projectStatus.cancelled || projectStatus.inCancellation) {
          return "CANCELLED";
        }
        if (!projectStatus.bidSelected) {
          return "PENDING";
        }
        if (projectStatus.closed) {
          return "COMPLETED";
        }
        return "OPEN,COMPLETED";
      };
    const uploadNewSourceFiles = (finalPayload,fileIndex)=>{
        var coId = ''
       if(finalPayload !== ''){
        setNewChangeOrderId(finalPayload.id)
        coId = finalPayload.id
       } else{
        coId = newChangeOrderId
       }
            setFileUploadProgress(0);
            setShowProgress(true);
            const params = {
                name: "SOURCE_ASSET",
                "project.id": param.id,
                docType: "SOURCE_ASSET",
                pId: param.id,
                coId: coId
            };
            postAxiosFormDataResponse(APIUrls.CHANGE_ORDER_META_DATA_SUBMIT, params)
            .then((res) => {
                var docFieldId = -1
                docFieldId = res.data.data.model.documentFileId;
                setDocumentFileId(docFieldId)
                if (docFieldId === -1) {
                    setCurrentFileIndex(fileIndex);
                } else {
                    setCurrentFileIndex(fileIndex);
                }
            }).catch((err) => {
                console.error('file upload error',err);
            });
     
    }
    const checkAutoBid = (e) =>{
         e.target.checked ? setAutoBid(true) : setAutoBid(false)
    }
    const updateChangeOrder = (id,payload)=>{
        putAxiosResponse(APIUrls.UPDATE_CHANGE_ORDER(id,payload.id),payload)
            .then((res) => {
                setShowCreateChangeOrder(false)
                prop.funct('changeOrder')
                prop.refreshChangeOrderList()
            }).catch((err) => {
                console.error(err);
            });
    };

    const handleDrop=(e)=>{
        e.preventDefault();
        if (e.dataTransfer) {
        setSelectedFiles(e.dataTransfer.files[0]);
        setSelectedFiles([e.dataTransfer.files[0]]);
        //setSelectedFiles((file)=>[...file,e.target.files[0]]);
        }
    };
    const setAssigneesToWorkFlow = (data,langcode) =>{
        var assignees = []
        if(typeof langcode !== 'string' && langcode.length > 0){

        }
        reviewAssigneeList.forEach((assignee)=>{
            if(assignee.reviewLanguages.includes(langcode)){
                assignees.push(assignee.customerUser)
            }
        })
        if(assignees.length > 0){
            data.steps.forEach((step)=>{
                step.phases.forEach((phase)=>{
                    if(phase.allowMultiAssignee){
                        phase.assigneeUsers = assignees
                    }
                })
            })
        }
        return data

    }
    const workflowLangAdded = (langUrl,langCode) => {
        getAxiosResponse(APIUrls.INIT_CHANGE_ORDER_PROJECT_WORKFLOW(param.id) +langUrl)
        .then((res) => {
        if (res.data !== "") {
            if(res.data.data.length > 1){
                res.data.data.forEach((data)=>{
                    data.steps = setAssigneesToWorkFlow(data.resource,langCode)
                    setNewSelectedLangs((current) => [...current, data]);
                    setUpdatedWorkFlow((current) => [...current, data.resource] );
                    })
            }else{
                res.data.data.forEach((data)=>{
                    data.steps = setAssigneesToWorkFlow(data.resource,langCode)
                    setNewSelectedLangs((current) => [...current, data]);
                    setUpdatedWorkFlow((current) => [...current, data.resource] );
                })
            }
            setButtonDisabled(false) 
        }
        }).catch((err) => {
        console.error(err);
        });
    };
    const workflowRemoved = (selected) => {
        if(updatedWorkflow.length > 0){
            var filteredWorkflow = updatedWorkflow.filter((workflow)=>{
                return workflow.language !== selected.language
            })
            setUpdatedWorkFlow(filteredWorkflow)
        }
    };

    const setShowCreateChangeOrder = (val)=>{
        reset();
        prop.showCOList(val);
    };
    const getPreviosPhaseDueDate = (wfgindex, stepNum, phaseNum) => {
        if(stepNum !== 1 && phaseNum === 1) {
          let noOfPhases = updatedWorkflow[wfgindex]?.steps[stepNum-2].phases.length;
          return updatedWorkflow[wfgindex]?.steps[stepNum-2]?.phases[noOfPhases-1]?.dueDate;
        }
        return updatedWorkflow[wfgindex]?.steps[stepNum-1]?.phases[phaseNum-2]?.dueDate;
      }
    const getDuration = (phaseDueDate, workflowGroup, wfgIndex, stepNum, phaseNum) => {
        phaseDueDate = dateUtil.getDateTimestamp(phaseDueDate);
        let previousPhaseDate = dateUtil.getDateTimestamp(getPreviosPhaseDueDate(wfgIndex, stepNum, phaseNum));
        if(phaseDueDate && previousPhaseDate) {
        let date1 = new Date(phaseDueDate);
        let date2 = new Date(previousPhaseDate);
        let timeDiff = date1.getTime() - date2.getTime();
        let dayDiff = Math.round(timeDiff / (1000 * 3600 * 24));
        if(dayDiff < 0) {
          const pf = { ...workflowGroup };
          const pfSteps = [...pf.steps];
          let phPhase;
          let phStep;
          pfSteps.map((pfstep, stepIndex) => {
            phStep = { ...pfstep };
            if (stepIndex === stepNum - 1) {
              const pfPhases = [...pfstep.phases];
              pfPhases.map((pfphase, index) => {
                if (index === phaseNum - 1) {
                  phPhase = { ...pfphase };
                  phPhase.dueDate = previousPhaseDate;
                  pfPhases[index] = phPhase;
                }
              });
              phStep.phases = pfPhases;
            }
            pfSteps[stepIndex] = phStep;
          });
          pf.steps = pfSteps;
          let updatedProjectWfs = [...updatedWorkflow];
          updatedProjectWfs[wfgIndex] = pf;
          
          
          
        }
        return dayDiff;
      }
      return Constants.BLANK;
      }
    const reset = ()=>{
        setOrderName("");
        setChangeOrderNote("");
    };
    
    const setAssigneeValue = (workflowGroup, stepIndex, phaseIndex,loopIndex) => {
        var phase = updatedWorkflow[loopIndex].steps[stepIndex].phases[phaseIndex]
            if (phase.assigneeUsers.length !== 0 && phase.assigneeUsers.length < 2 && !phase.allowMultiAssignee) {
            return (
                <span aria-label={`user ${phase.assigneeUsers[0].firstName +" " +
                phase.assigneeUsers[0].lastName} selected`}>
                {phase.assigneeUsers[0].firstName +" " +
                    phase.assigneeUsers[0].lastName}
                </span>
            );
            } else {
                var assigneeUsers = ''
                phase.assigneeUsers.map((user,index)=>{
                    if(phase.assigneeUsers.length === index+1){
                        assigneeUsers += user.firstName+' '+user.lastName   
                    }else{
                        assigneeUsers += user.firstName+' '+user.lastName+', '   
                    } 
                })
                return (
                    <span aria-label={`user ${assigneeUsers} selected`}>
                    {phase.allowMultiAssignee ? assigneeUsers.length > 1 ? `Reviewers (${phase.assigneeUsers.length})`: assigneeUsers.length === 1 ? assigneeUsers :
                     "Multiple Assignees" : "Single Assignee"}
                    </span>
                );
            }
    };
    const languageApproved = (lang) =>{
        var langCode = lang.value
        var accepted = '';
        if(languageDeliverableStatus.length > 0){
             languageDeliverableStatus.forEach((deliverable)=>{
                if(deliverable.displayName[0].code === langCode){
                    if(deliverable.resource.languageStatus === "APPROVED"){
                        accepted  = langCode;
                    }
                    else{
                        accepted = '';
                    }
                }
            })
        return accepted
        }
        
    }
    const langOriginallyAdded = (code) =>{
        const codesArray2 = prop.projectDetail.displayName[0].targetLanguages.map((item) => item.code);
        const filteredArray1 = newSelectedLangs.filter((item) =>
        !codesArray2.includes(item.displayName[0].code)
        );
        return filteredArray1
    }
    const getMessage=()=>{
        return(
            <div className='react-confirmPopup'>

                {langOriginallyAdded().length > 0 ?
                    <p>
                        <strong>Additional Project Language(s): </strong>
                        {langOriginallyAdded().map((lang,idx)=>{
                                return(
                                    <span key={idx}>{idx > 0?", "+lang.displayName[0]?.display:lang.displayName[0]?.display}</span>
                                )
                        })}
                    </p>
                :Constants.BLANK}
                {actualRemovedLang.length > 0 ? 
                 <p>
                 <strong>Removed Project Language(s): </strong>
                 {actualRemovedLang.map((lang,idx)=>{
                     return(
                         <span key={idx}>{idx>0?", "+lang.label:lang.label}</span>
                     )
                 })}
             </p>
         :Constants.BLANK
                }
                {selectedFiles.length>0?
                    <p>
                        <strong>Source File Added: </strong>
                        {selectedFiles.map((file,idx)=>{
                            return (
                                <>
                                    <span key={idx}>{idx>0?", "+file.name:file.name}</span>
                                </>
                            )})}
                    </p>
                :Constants.BLANK}
                 
                {deletedFiles.length >0?
                <p>
                <strong>Source Files Removed: </strong>
                {deletedFiles.map((file,idx)=>{
                    return (
                        <>
                            <span key={idx}>{idx>0?", "+file.name:file.name}</span>
                        </>
                    )
                })}
                </p>
                :Constants.BLANK}
                {(selectedFiles.length === 0 && deletedFiles.length === 0 && (langOriginallyAdded().length > 0 || removedLangs.length > 0)) ? 
                    <p>No changes to file(s) have been made.</p>
                    :Constants.BLANK}
                {((selectedFiles.length > 0 || deletedFiles.length > 0) && (langOriginallyAdded().length === 0 && removedLangs.length === 0)) ? 
                    <p>No changes to language(s) have been made.</p>
                    :Constants.BLANK}    
                {(langOriginallyAdded().length === 0 && deletedFiles.length === 0 && selectedFiles.length === 0 && removedLangs.length === 0) ? 
                    <p>No changes to language(s) or file(s) have been made.</p>
                    :Constants.BLANK}
                
                <p>{translate("change_order.notified")}</p>
            </div>
        );
    };

    const setDurationInDays = (step,phase,phaseNum,stepNum, workflowGroup,wfgIndex,newlang) => {
        let previousDate = getPreviosPhaseDueDate(wfgIndex, stepNum, phaseNum);
        previousDate = dateUtil.convertToServerDateTimestamp(previousDate);
        if (step.stepNumber !== 1 && phase.phaseNumber === 1 && (phase.phaseType.display === "Work" || phase.phaseType.display === "Review")) {
        return workflowGroup.templateType.code ===
            "builtin_single_step" ? (
            <button className="step-cal 1" aria-label="Due date calendar" aria-expanded={dueDateCalendarExpanded}
            onClick={(e) => {openCalendar(`calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`,e);}}>
            <svg className="calender-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" >
                <path d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z" fill="#3564EB" />
            </svg>
            <span className="due-date"></span>
            <div className={showCalendar ===`calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`
                    ? `popover-body-calendar global-dropdown-block m-0 show-assignee-dropdown calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`
                    : `popover-body popover-body-calendar global-dropdown-block m-0 calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`}  >
                <div className="triangle-with-shadow"></div>
                <div className="inner-popover">
                <Calendar calendarType="US" locale="en"
                    onChange={(value, event) => {
                    changeDate(value,event,phaseNum,stepNum,workflowGroup,wfgIndex );
                    }}
                    minDate={previousDate ? new Date(previousDate):new Date()}
                    navigationLabel={ ({ date, label, locale, view })=>showCustomNavigationLabel(date, label, locale, view)}
                    onViewChange={({ action, activeStartDate, value, view }) => viewChange(action, activeStartDate, value, view)}
                    nextAriaLabel={nextAriaLabel}
                    prevAriaLabel={prevAriaLabel}
                    next2AriaLabel={next2AriaLabel}
                    prev2AriaLabel={prev2AriaLabel}
                    className="dashCalendar"
                ></Calendar>
                </div>
            </div>
            </button>
        ) : (
            <button className="step-cal 2" aria-label="Due date calendar" aria-expanded={dueDateCalendarExpanded}
            onClick={(e) => {openCalendar(`calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`,e);}}
            style={validationError[`wf.phaseDueDate.${newlang.displayName[0].code}_${step.stepNumber}_${phase.phaseNumber}`] === 'Due date required' ||
            validationError[`wf.workflowDate.${newlang.displayName[0].code}_${step.stepNumber}_${phase.phaseNumber}`] === 'Date is before initial due date'
                ? {border:"2px solid #A61616",padding:"0px 2px",borderRadius:"5px"}: null}>
            <span>
            {getDuration(phase.dueDate, workflowGroup, wfgIndex, stepNum, phaseNum)}
            </span>
            {phase.dueDate ?
            <>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none" >
                <path d="M12.3536 4.35355C12.5488 4.15829 12.5488 3.84171 12.3536 3.64645L9.17157 0.464465C8.97631 0.269203 8.65973 0.269203 8.46447 0.464465C8.2692 0.659728 8.2692 0.97631 8.46447 1.17157L11.2929 4L8.46447 6.82843C8.2692 7.02369 8.2692 7.34027 8.46447 7.53553C8.65973 7.7308 8.97631 7.7308 9.17157 7.53553L12.3536 4.35355ZM4.37114e-08 4.5L1 4.5L1 3.5L-4.37114e-08 3.5L4.37114e-08 4.5ZM3 4.5L5 4.5L5 3.5L3 3.5L3 4.5ZM7 4.5L9 4.5L9 3.5L7 3.5L7 4.5ZM11 4.5L12 4.5L12 3.5L11 3.5L11 4.5Z" fill="#2F3865" />
            </svg>
            <span className="due-date">
                <DateFormat date={phase.dueDate} format={DATE_FORMATS.MONTH_DAY} timezone={null} />
            </span>
            </> : <span className="due-date">
                Select date
            </span>}
            <div className={showCalendar ===`calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`
                    ? `popover-body-calendar global-dropdown-block m-0 show-assignee-dropdown calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`
                    : `popover-body popover-body-calendar global-dropdown-block m-0 calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`}>
                <div className="triangle-with-shadow"></div>
                <div className="inner-popover">
                <Calendar calendarType="US" locale="en"
                    onChange={(value, event) => {
                    changeDate(value,event,phaseNum,stepNum,workflowGroup,wfgIndex);
                    }}
                    minDate={getMinDate(step,phase,phaseNum,stepNum, workflowGroup,wfgIndex)}
                    navigationLabel={ ({ date, label, locale, view })=>showCustomNavigationLabel(date, label, locale, view)}
                    onViewChange={({ action, activeStartDate, value, view }) => viewChange(action, activeStartDate, value, view)}
                    nextAriaLabel={nextAriaLabel}
                    prevAriaLabel={prevAriaLabel}
                    next2AriaLabel={next2AriaLabel}
                    prev2AriaLabel={prev2AriaLabel}
                    className="dashCalendar"
                ></Calendar>
                </div>
            </div>
            </button>
        );
        } else if (phase.phaseNumber !== 1 && (phase.phaseType.display === "Work" || phase.phaseType.display === "Review")) {
        return workflowGroup.templateType.code === "builtin_single_step" ? (
            <button className="step-cal 3" aria-label="Due date calendar" aria-expanded={dueDateCalendarExpanded}
            onClick={(e) => {openCalendar(`calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`,e);}}>
            <svg className="calender-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" >
                <path d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z" fill="#3564EB" />
            </svg>
            <span className="due-date">
                <DateFormat date={phase.dueDate} format={DATE_FORMATS.MONTH_DAY} timezone={null} />
            </span>
            <div className={showCalendar ===`calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`
                    ? `popover-body-calendar global-dropdown-block m-0 show-assignee-dropdown calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`
                    : `popover-body popover-body-calendar global-dropdown-block m-0 calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`}>
                {/* <div className="triangle-with-shadow "></div> */}
                <div className="global-dropdown-block">
                <Calendar calendarType="US" locale="en"
                    onChange={(value, event) => {changeDate(value,event,phaseNum,stepNum,workflowGroup,wfgIndex);}} 
                    navigationLabel={ ({ date, label, locale, view })=>showCustomNavigationLabel(date, label, locale, view)}
                    onViewChange={({ action, activeStartDate, value, view }) => viewChange(action, activeStartDate, value, view)}
                    nextAriaLabel={nextAriaLabel}
                    prevAriaLabel={prevAriaLabel}
                    next2AriaLabel={next2AriaLabel}
                    prev2AriaLabel={prev2AriaLabel}
                    className="dashCalendar"
                    minDate={previousDate ? new Date(previousDate):new Date()}
                ></Calendar>
                </div>
            </div>
            </button>
        ) : (
            <button className="step-cal 4" aria-label="Due date calendar" aria-expanded={dueDateCalendarExpanded} 
            onClick={(e) => {openCalendar(`calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`,e);}}
            style={validationError[`wf.phaseDueDate.${newlang.displayName[0].code}_${step.stepNumber}_${phase.phaseNumber}`] === 'Due date required' || 
            validationError[`wf.workflowDate.${newlang.displayName[0].code}_${step.stepNumber}_${phase.phaseNumber}`] === 'Date is before initial due date'
                ? {border:"2px solid #A61616",padding:"0px 2px",borderRadius:"5px"}: null}>
            <span>
                {getDuration(phase.dueDate, workflowGroup, wfgIndex, stepNum, phaseNum)}
            </span>
            {phase.dueDate ?
            <>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none" >
                <path d="M12.3536 4.35355C12.5488 4.15829 12.5488 3.84171 12.3536 3.64645L9.17157 0.464465C8.97631 0.269203 8.65973 0.269203 8.46447 0.464465C8.2692 0.659728 8.2692 0.97631 8.46447 1.17157L11.2929 4L8.46447 6.82843C8.2692 7.02369 8.2692 7.34027 8.46447 7.53553C8.65973 7.7308 8.97631 7.7308 9.17157 7.53553L12.3536 4.35355ZM4.37114e-08 4.5L1 4.5L1 3.5L-4.37114e-08 3.5L4.37114e-08 4.5ZM3 4.5L5 4.5L5 3.5L3 3.5L3 4.5ZM7 4.5L9 4.5L9 3.5L7 3.5L7 4.5ZM11 4.5L12 4.5L12 3.5L11 3.5L11 4.5Z" fill="#2F3865" />
            </svg>
            <span className="due-date">
                <DateFormat date={phase.dueDate} format={DATE_FORMATS.MONTH_DAY} timezone={null}/>
            </span>
            </> : <span className="due-date">
                Select date
            </span>}
            <div className={showCalendar ===`calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`
                    ? `popover-body-calendar global-dropdown-block m-0 show-assignee-dropdown calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`
                    : `popover-body popover-body-calendar global-dropdown-block m-0 calendar-${wfgIndex + "-" + stepNum + "-" + phaseNum}`}>
                <div className="triangle-with-shadow"></div>
                <div className="inner-popover">
                <Calendar calendarType="US" locale="en"
                    onChange={(value, event) => {changeDate(value,event,phaseNum,stepNum,workflowGroup,wfgIndex);}}
                    minDate={getMinDate(step,phase,phaseNum,stepNum, workflowGroup,wfgIndex)}
                    navigationLabel={ ({ date, label, locale, view })=>showCustomNavigationLabel(date, label, locale, view)}
                    onViewChange={({ action, activeStartDate, value, view }) => viewChange(action, activeStartDate, value, view)}
                    nextAriaLabel={nextAriaLabel}
                    prevAriaLabel={prevAriaLabel}
                    next2AriaLabel={next2AriaLabel}
                    prev2AriaLabel={prev2AriaLabel}
                    className="dashCalendar"
                ></Calendar>
                </div>
            </div>
            </button>
        );
        } else {
        return (
            <div className="step-cal 5 inline-flex disable-focus" aria-label="Due date calendar">
            <span>
                <DateFormat date={phase.dueDate} format={DATE_FORMATS.MONTH_DAY} timezone={null} />
            </span>
            <div className="popover-body popover-body-calendar">
                <div className="triangle-with-shadow"></div>
                <div className="inner-popover">
                <Calendar calendarType="US" locale="en"
                    onChange={(value, event) => { changeDate(value,event,phaseNum,stepNum,workflowGroup,wfgIndex ); }}
                    navigationLabel={ ({ date, label, locale, view })=>showCustomNavigationLabel(date, label, locale, view)}
                    onViewChange={({ action, activeStartDate, value, view }) => viewChange(action, activeStartDate, value, view)}
                    nextAriaLabel={nextAriaLabel}
                    prevAriaLabel={prevAriaLabel}
                    next2AriaLabel={next2AriaLabel}
                    prev2AriaLabel={prev2AriaLabel}
                    className="dashCalendar"
                    minDate={previousDate ? new Date(previousDate):new Date()}
                ></Calendar>
                </div>
            </div>
            </div>
        );
        }
    };

    const MultipleFilesRendered = ()=>{
        // //{selectedFiles.map((file,idx)=>{
        //                    // return (
        //                     //    <>
        //                         <div className="inline-flex">
        //                             <strong className={file ? "show-flex" : "hide"}>
        //                                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none" >
        //                                 <path d="M6.71373 3.85714V2.57143H5.42801V3.85714H6.71373ZM7.99944 5.14286V3.85714H6.71373V5.14286H7.99944ZM6.71373 6.42857V5.14286H5.42801V6.42857H6.71373ZM7.99944 7.71429V6.42857H6.71373V7.71429H7.99944ZM15.0307 3.81696C15.2182 4.00446 15.3789 4.25893 15.5128 4.58036C15.6468 4.90179 15.7137 5.19643 15.7137 5.46429V17.0357C15.7137 17.3036 15.62 17.5312 15.4325 17.7188C15.245 17.9062 15.0173 18 14.7494 18H1.24944C0.981585 18 0.753906 17.9062 0.566406 17.7188C0.378906 17.5312 0.285156 17.3036 0.285156 17.0357V0.964286C0.285156 0.696429 0.378906 0.46875 0.566406 0.28125C0.753906 0.09375 0.981585 0 1.24944 0H10.2494C10.5173 0 10.8119 0.0669643 11.1334 0.200893C11.4548 0.334821 11.7093 0.495536 11.8968 0.683036L15.0307 3.81696ZM10.5709 1.36607V5.14286H14.3477C14.2807 4.94866 14.207 4.81138 14.1267 4.73103L10.9827 1.58705C10.9023 1.5067 10.7651 1.43304 10.5709 1.36607ZM14.428 16.7143V6.42857H10.2494C9.98158 6.42857 9.75391 6.33482 9.56641 6.14732C9.37891 5.95982 9.28516 5.73214 9.28516 5.46429V1.28571H7.99944V2.57143H6.71373V1.28571H1.57087V16.7143H14.428ZM8.13002 9.4721L9.2048 12.9777C9.25837 13.1585 9.28516 13.3326 9.28516 13.5C9.28516 14.0558 9.04241 14.5162 8.55692 14.8811C8.07143 15.2461 7.45703 15.4286 6.71373 15.4286C5.97042 15.4286 5.35603 15.2461 4.87054 14.8811C4.38504 14.5162 4.1423 14.0558 4.1423 13.5C4.1423 13.3326 4.16908 13.1585 4.22266 12.9777C4.36328 12.5558 4.76507 11.2299 5.42801 9V7.71429H6.71373V9H7.50725C7.65458 9 7.78516 9.04353 7.899 9.13058C8.01283 9.21763 8.08984 9.33147 8.13002 9.4721ZM6.71373 14.1429C7.06864 14.1429 7.37165 14.0792 7.62277 13.952C7.87388 13.8248 7.99944 13.6741 7.99944 13.5C7.99944 13.3259 7.87388 13.1752 7.62277 13.048C7.37165 12.9208 7.06864 12.8571 6.71373 12.8571C6.35882 12.8571 6.0558 12.9208 5.80469 13.048C5.55357 13.1752 5.42801 13.3259 5.42801 13.5C5.42801 13.6741 5.55357 13.8248 5.80469 13.952C6.0558 14.0792 6.35882 14.1429 6.71373 14.1429Z" fill="#157EFB" ></path>
        //                                 </svg>
        //                             </strong>
        //                             <span>{file?.name}</span>
        //                         </div>
        //                     //    </>
        //                    // )
        //                 })}
    }

    return (
        <>
            <div className="campaign_details-task-create-form" style={{overflow:"inherit"}}>
                <div className="projects-heading">
                    <div className="title">
                        <h5>{translate("change_order.create_new_change_order")}</h5>
                        <p>
                         {translate("change_order.create_change_order")}
                        </p>
                    </div>
                    <button className="btn-bold firstBtnFocus" onClick={() => setShowCreateChangeOrder(false)}>
{translate("change_order.back_change_order")}                    </button>
                </div>
                <div className="task-form-content">
                    <div className="form-group">
                    <div className="form-text">
                        <label htmlFor="changeOrder">{translate("change_order.change_order_name")}</label>
                        <br />
                        <input id="changeOrder" className='form-control-sm' type="text" name="change Order" aria-required='true'
                        onChange={(e) => handleOrderNameChange(e.target.value)} maxLength={50}/>
                        <div>{charsLeftName.toLocaleString()} characters left</div>
                    </div>
                    </div>
                    <div className="form-group">
                    <div className="form-text">
                        <label htmlFor='changeDesc'>{translate("change_order.notes")}</label>
                        <textarea id='changeDesc' className="textarea" aria-required='true' placeholder="1000 characters limit" maxLength={1000}
                        onChange={(event) => handleAreaChange(event.target.value)}>
                        </textarea>
                        <div>{charsLeft.toLocaleString()} characters left</div>
                    </div>
                    </div>
                    <div className="source-file">
                        <div className="source-header flex-center">
                            <h4>{translate("change_order.change_project_source_file")}</h4>
                        </div>
                        {!uiFeatures.CHANGE_SOURCE_MATERIAL ?
                        <div className='flex align-items'>
                             <p>{Constants.CHANGE_ORDER_FILE_CHANGE_UI_FEATURES}</p>{" "}
                        </div> : 
                        !isAllowedToChangeSource()  ? 
                        <div className='flex align-items'>
                        <p>{Constants.CHANGE_ORDER_FILE_CHANGE_NOT_ALLOWED_FOR_LANG_APPROVED}</p>{" "}
                        <Link className="pl-5" onClick={(e)=>{e.preventDefault();prop.funct('overView')}}>translations tab.</Link>
                        </div> : 
                        <div className='wrap-source-file-item'>
                        {sourceAsset.length !== 0 ? sourceAsset.map((source, index) => {
                                return (
                                    <div className="source-file-item" key={index} id={`source-${source.id}`}>
                                        <div className="left flex">
                                            <div className="icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none" >
                                                <path d="M7.31677 0.900024C7.66837 0.900024 8.01206 0.995054 8.31219 1.17323L8.48677 1.29002L10.5672 2.85002H18.1501C19.8015 2.85002 21.1651 4.08161 21.3727 5.67634L21.3932 5.88633L21.4001 6.10002V15.85C21.4001 17.5732 20.0591 18.983 18.3638 19.0931L18.1501 19.1H3.8501C2.12697 19.1 0.717046 17.7591 0.607014 16.0637L0.600098 15.85V4.15002C0.600098 2.4269 1.9411 1.01697 3.6364 0.906941L3.8501 0.900024H7.31677ZM16.2062 4.15002H14.9062V7.40002H16.2062V4.15002ZM13.6062 4.15002H10.5022L8.60502 6.14486C8.28298 6.48301 7.85199 6.69272 7.39175 6.73987L7.19296 6.75002L1.9001 6.74872V15.85C1.9001 16.8636 2.67345 17.6965 3.6623 17.7911L3.8501 17.8H14.9058L14.905 16.581C14.9018 16.5545 14.9001 16.5275 14.9001 16.5C14.9001 16.4729 14.9018 16.4461 14.905 16.4198L14.9043 15.2H14.2562C13.8971 15.2 13.6062 14.909 13.6062 14.55C13.6062 14.1911 13.8971 13.9 14.2562 13.9H14.9036L14.902 11.3H14.9001H14.2501C13.8912 11.3 13.6001 11.009 13.6001 10.65C13.6001 10.2911 13.8912 10 14.2501 10H14.9001L14.9006 8.70002H14.2562C14.0837 8.70002 13.9185 8.63154 13.7965 8.50964C13.6746 8.38775 13.6062 8.22242 13.6062 8.05002V4.15002ZM16.2046 15.85H16.8501C17.209 15.85 17.5001 16.1411 17.5001 16.5C17.5001 16.859 17.209 17.15 16.8501 17.15H16.2054L16.2058 17.8H18.1501C19.1637 17.8 19.9966 17.0267 20.0911 16.0379L20.1001 15.85V6.10002C20.1001 5.08641 19.3267 4.25344 18.3379 4.15896L18.1501 4.15002H17.5062V8.05002C17.5062 8.40901 17.2151 8.70002 16.8562 8.70002H16.2006L16.2024 11.95H16.8562C17.2151 11.95 17.5062 12.2411 17.5062 12.6C17.5062 12.959 17.2151 13.25 16.8562 13.25H16.2032L16.2039 14.4956C16.2054 14.5135 16.2062 14.5317 16.2062 14.55C16.2062 14.5681 16.2054 14.586 16.204 14.6037L16.2046 15.85ZM7.31677 2.20002H3.8501C2.83649 2.20002 2.00351 2.97338 1.90903 3.96223L1.9001 4.15002V5.44872L7.19296 5.45002C7.33527 5.45002 7.47261 5.40337 7.58466 5.31875L7.66365 5.2483L9.3023 3.52732L7.70677 2.33002C7.62239 2.26674 7.52431 2.22526 7.42121 2.20847L7.31677 2.20002Z" fill="#128FEB"></path>
                                                </svg>
                                            </div>
                                            <div className="text">
                                                <p>{source.name}</p>
                                                <span>
                                                    <DateFormat date={source.createdDate} />
                                                </span>
                                                <span>{source.files.FINAL.documentFile.sizeInKilobytes} KB</span>
                                            </div>
                                            </div>
                                        <div className="right">
                                            <button aria-label="delete icon" className="delete-icon" onClick={() => deleteSourceFile(source)} >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" >
                                                <path d="M8.20039 3.80078H11.8004C11.8004 3.32339 11.6107 2.86555 11.2732 2.52799C10.9356 2.19042 10.4778 2.00078 10.0004 2.00078C9.523 2.00078 9.06516 2.19042 8.7276 2.52799C8.39003 2.86555 8.20039 3.32339 8.20039 3.80078ZM7.00039 3.80078C7.00039 3.00513 7.31646 2.24207 7.87907 1.67946C8.44168 1.11685 9.20474 0.800781 10.0004 0.800781C10.796 0.800781 11.5591 1.11685 12.1217 1.67946C12.6843 2.24207 13.0004 3.00513 13.0004 3.80078H19.0004C19.1595 3.80078 19.3121 3.864 19.4247 3.97652C19.5372 4.08904 19.6004 4.24165 19.6004 4.40078C19.6004 4.55991 19.5372 4.71252 19.4247 4.82505C19.3121 4.93757 19.1595 5.00078 19.0004 5.00078H17.7356L16.3028 17.4136C16.2015 18.291 15.7812 19.1006 15.1218 19.6883C14.4625 20.2759 13.61 20.6007 12.7268 20.6008H7.27399C6.39074 20.6007 5.53833 20.2759 4.87895 19.6883C4.21958 19.1006 3.79927 18.291 3.69799 17.4136L2.26519 5.00078H1.00039C0.841261 5.00078 0.688648 4.93757 0.576127 4.82505C0.463605 4.71252 0.400391 4.55991 0.400391 4.40078C0.400391 4.24165 0.463605 4.08904 0.576127 3.97652C0.688648 3.864 0.841261 3.80078 1.00039 3.80078H7.00039ZM4.88959 17.2768C4.9573 17.8617 5.23765 18.4012 5.67729 18.7929C6.11694 19.1845 6.68521 19.4009 7.27399 19.4008H12.7268C13.3156 19.4009 13.8838 19.1845 14.3235 18.7929C14.7631 18.4012 15.0435 17.8617 15.1112 17.2768L16.5272 5.00078H3.47359L4.88959 17.2768ZM8.20039 8.00078C8.35952 8.00078 8.51213 8.06399 8.62466 8.17652C8.73718 8.28904 8.80039 8.44165 8.80039 8.60078V15.8008C8.80039 15.9599 8.73718 16.1125 8.62466 16.225C8.51213 16.3376 8.35952 16.4008 8.20039 16.4008C8.04126 16.4008 7.88865 16.3376 7.77613 16.225C7.6636 16.1125 7.60039 15.9599 7.60039 15.8008V8.60078C7.60039 8.44165 7.6636 8.28904 7.77613 8.17652C7.88865 8.06399 8.04126 8.00078 8.20039 8.00078ZM12.4004 8.60078C12.4004 8.44165 12.3372 8.28904 12.2247 8.17652C12.1121 8.06399 11.9595 8.00078 11.8004 8.00078C11.6413 8.00078 11.4886 8.06399 11.3761 8.17652C11.2636 8.28904 11.2004 8.44165 11.2004 8.60078V15.8008C11.2004 15.9599 11.2636 16.1125 11.3761 16.225C11.4886 16.3376 11.6413 16.4008 11.8004 16.4008C11.9595 16.4008 12.1121 16.3376 12.2247 16.225C12.3372 16.1125 12.4004 15.9599 12.4004 15.8008V8.60078Z" fill="#6D7080" ></path>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                );
                            }):  <div className="source-file-item">
                                <strong></strong>
                            </div>
                            
                        }
                        </div>
                        
                       
                    }
                    </div>

                    {uiFeatures.CHANGE_TARGET_LANGUAGES && projectResource.projectContentType !== "post" && projectResource.projectContentType !== "page" ?
                    !leastOneLangApproved ? 
                    <div className="upload-main">
                    <h5>{translate("change_order.new_source_file")}</h5>
                    <div className="upload-file-container flex" onDragOver={(e) => { e.preventDefault(); }}
                        onDragLeave={(e) => { e.preventDefault(); }} onDrop={(e) => handleDrop(e)} >
                        <div className="right-side">
                        <div className="upload-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none" >
                            <path d="M31.125 34C31.125 34 38.398 34 39.0857 34C42.9051 34 46 30.8778 46 27.0255C46 23.1733 42.9051 20.0502 39.0857 20.0502C39.0682 20.0502 39.0525 20.0528 39.035 20.0528C39.0884 19.6168 39.1251 19.1754 39.1251 18.7252C39.1251 12.8021 34.366 8 28.4939 8C23.9185 8 20.0309 10.921 18.5311 15.0098C17.58 14.0485 16.264 13.4526 14.8115 13.4526C11.9074 13.4526 9.55363 15.8272 9.55363 18.7561C9.55363 18.8311 9.56238 18.9035 9.565 18.9777C6.35813 19.8719 4 22.8281 4 26.3476C4 30.5741 7.39588 34 11.5863 34C12.3099 34 18.875 34 18.875 34" stroke="#96ACCC" strokeWidth="2.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" ></path>
                            <path d="M21 28L25 23L29 28" stroke="#96ACCC" strokeWidth="2.5" strokeMiterlimit="10" strokeLinecap="round" ></path>
                            <path d="M25 41V24" stroke="#96ACCC" strokeWidth="2.5" strokeMiterlimit="10" strokeLinecap="round" ></path>
                            </svg>
                        </div>
                        <div className="upload-format">
                            JPG, PNG, HTML , PDF
                            <div className="more-format">
                            <button aria-label="more formats">more formats...</button>
                            <div className="more-format-popup">
                                <div className="triangle-with-shadow"></div>
                                <ul>
                                <li>DITA_Files</li>
                                <li>DOCX</li>
                                <li>HTML</li>
                                <li>IDML</li>
                                <li>JAVA_PROP</li>
                                <li>JSON</li>
                                <li>MIF</li>
                                <li>Open_Office_Files</li>
                                <li>PHP</li>
                                <li>PO</li>
                                <li>POT</li>
                                <li>PPTX</li>
                                <li>PSD</li>
                                <li>RAIL</li>
                                <li>RESX</li>
                                <li>SRT</li>
                                <li>STRINGS</li>
                                <li>TXT</li>
                                <li>XML</li>
                                </ul>
                            </div>
                            </div>{" "}
                            ( {accountPermission?.maxFileUploadSizeGb} GB or less)
                        </div>
                        <div className="file-drag">Drag and drop your file or</div>
                            <div className="input-file-container">
                                <div className="input-file mar-bot16">
                                <input type="file" id="files" onChange={(e) => fileSelection(e)} onClick={(e) => clearValue(e)} multiple/>
                                <label className="file-button" htmlFor="files">
                                {selectedFiles.length > 0 ? 'Replace file': 'Choose file'}
                                </label>
                                </div>
                            </div>
                            {selectedFiles.length > 0 ? 
                            <div className="input-file mar-bot16">
                            <input type="file" id="anotherfile" onChange={(e) => addAnother(e)} onClick={(e) => clearValue(e)} multiple/>
                            <label className="file-button" htmlFor="files">
                            Add another
                            </label>
                            </div> : ''
                            }
                            {selectedFiles.length > 0 ?
                            selectedFiles.map((file)=>{
                            return(<div className="upload-file-ext">
                                <div className="inline-flex">
                                    <strong >
                                        {currentFileIndex !== null && selectedFiles[currentFileIndex].name !== file.name ?
                                    FileIcon :ZipfileIcon
                                          }
                                    </strong>
                                    <span>{file?.name} {!fileUploadPermission ?Constants.BLANK:sizeConvertInGb(file).toFixed(2) + " GB"}</span>
                                </div>
                            </div>)
                            })
                            :''
                            }
                            {!fileUploadPermission ?Constants.BLANK:<span className="textDanger">File size exceeds {accountPermission.maxFileUploadSizeGb} GB.</span>}

                        </div>
                    </div>
                    <div className={showProgress ? "right-progressbar" : "right-progressbar hide"}>
                        <CustomProgressBar completed={fileUploadProgress}
                        labelLineHeight="1px" labelSize="14px" width="100%" labelClassName="progressBarLabel" borderRadius = "30px" labelAlignment="outside" labelColor="rgba(0,0,0,0.87)" height="10px" className="file_upload_progress" bgColor="#06B878" baseBgColor="#D1DEF0"
                        ariaValuetext={fileUploadProgress} aria-label="" aria-valuenow={fileUploadProgress} />
                        </div>
                    {/* 
                    <div className="uploading-files-block hide">
                        <small>Sit Tight while we're uploading your files…</small>
                        <div className="uploading-file-list">
                        here showing file section
                        </div>
                    </div>
                    <div className="uploading-files-block uploading-success hide">
                        <small>File Uploaded Successfully!</small>
                        <div className="uploading-file-list flex">
                        <div className="left-file-desc flex-center">
                            <div className="icon-block">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none" >
                                <path d="M19.3612 24.1735H5.63886C4.72272 24.1723 3.84447 23.8078 3.19673 23.1599C2.54899 22.5121 2.18464 21.6338 2.18359 20.7176V4.28144C2.18481 3.36542 2.54924 2.48727 3.19696 1.83955C3.84469 1.19182 4.72284 0.827397 5.63886 0.826178H14.402C14.8572 0.825314 15.3081 0.914634 15.7286 1.08898C16.1491 1.26333 16.531 1.51925 16.852 1.84197L21.8 6.78539C22.4488 7.43731 22.8141 8.31894 22.8165 9.23868V20.7176C22.8154 21.6338 22.4511 22.5121 21.8034 23.1599C21.1556 23.8078 20.2774 24.1723 19.3612 24.1735ZM5.63886 2.47091C5.15889 2.47161 4.69878 2.66259 4.35939 3.00197C4.02 3.34136 3.82903 3.80147 3.82833 4.28144V20.7176C3.82903 21.1977 4.01998 21.6578 4.35935 21.9973C4.69872 22.3368 5.15883 22.5279 5.63886 22.5288H19.3612C19.8413 22.5279 20.3014 22.3368 20.6407 21.9973C20.9801 21.6578 21.1711 21.1977 21.1717 20.7176V9.2367C21.1706 8.75346 20.9786 8.29024 20.6375 7.94789L15.6895 3.00447C15.5208 2.83483 15.3202 2.70033 15.0992 2.60874C14.8782 2.51716 14.6412 2.47031 14.402 2.47091H5.63886Z" fill="#EA6404" ></path>
                                <path d="M21.2624 9.02539H18.1999C17.2868 9.02452 16.4113 8.66138 15.7656 8.01568C15.1199 7.36998 14.7567 6.49447 14.7559 5.58131V1.65039H16.4006V5.58131C16.4011 6.05837 16.5909 6.51573 16.9282 6.85306C17.2655 7.19039 17.7229 7.38013 18.1999 7.38065H21.2624V9.02539Z" fill="#EA6404" ></path>
                                <path d="M9.09858 16.2195C9.0335 16.2177 8.96983 16.2001 8.91305 16.1682C8.84727 16.134 8.77753 16.0958 8.70319 16.0537L6.1374 14.5458C6.07628 14.5057 6.02717 14.4498 5.99529 14.384C5.96422 14.3214 5.94779 14.2525 5.94727 14.1827C5.94722 14.1102 5.96364 14.0387 5.99529 13.9735C6.02596 13.9088 6.07551 13.8549 6.1374 13.8189L8.70319 12.3432C8.76483 12.3046 8.82978 12.2716 8.89727 12.2445C8.95114 12.2222 9.0087 12.2101 9.067 12.209C9.12446 12.2118 9.18064 12.2269 9.23173 12.2534C9.28281 12.2798 9.32761 12.317 9.36305 12.3623C9.44775 12.4479 9.49708 12.5623 9.50121 12.6827C9.50051 12.737 9.48529 12.7902 9.45713 12.8366C9.42521 12.891 9.37991 12.9363 9.32555 12.9682L6.58608 14.5557L6.53082 13.7662L9.31766 15.4327C9.37448 15.4644 9.42036 15.5125 9.44924 15.5708C9.475 15.6235 9.48849 15.6813 9.48871 15.7399C9.48922 15.8646 9.44217 15.9849 9.35713 16.0761C9.32648 16.1168 9.28762 16.1505 9.24308 16.1752C9.19855 16.2 9.14932 16.215 9.09858 16.2195Z" fill="#EA6404" ></path>
                                <path d="M9.09903 16.3842C9.00676 16.3829 8.91629 16.3585 8.83588 16.3132C8.77009 16.2796 8.69772 16.2401 8.6214 16.1967L6.05232 14.6882C5.96296 14.631 5.89121 14.5502 5.84509 14.4546C5.80286 14.3702 5.78036 14.2773 5.7793 14.1829C5.78005 14.0858 5.80253 13.99 5.84509 13.9026C5.88955 13.8086 5.96161 13.7304 6.05167 13.6783L8.61745 12.2007C8.68592 12.1578 8.75815 12.1212 8.83324 12.0915C8.94371 12.0425 9.06734 12.0318 9.18457 12.061C9.30181 12.0902 9.40598 12.1576 9.48061 12.2526C9.5932 12.368 9.65785 12.5218 9.66153 12.6829C9.6609 12.7661 9.6382 12.8476 9.59574 12.9191C9.55045 12.9955 9.48693 13.0594 9.41088 13.1053L7.55496 14.1836L9.40759 15.2888C9.4929 15.3369 9.5617 15.4096 9.60496 15.4974C9.64142 15.5722 9.66053 15.6543 9.66088 15.7375C9.66142 15.9022 9.60014 16.0612 9.48917 16.1829C9.44246 16.2426 9.38342 16.2914 9.31609 16.3262C9.24876 16.3609 9.17472 16.3807 9.09903 16.3842ZM6.69443 14.6823L8.78719 15.9119C8.85759 15.9526 8.92469 15.9888 8.98917 16.0224C9.03118 16.0446 9.07979 16.0509 9.12608 16.0401C9.17237 16.0294 9.21322 16.0023 9.24114 15.9638C9.29873 15.9027 9.33033 15.8215 9.3293 15.7375C9.32891 15.7033 9.32081 15.6695 9.30561 15.6388C9.28959 15.6106 9.26555 15.5877 9.23653 15.573L7.22995 14.3724L6.69443 14.6823ZM6.37535 13.873L6.22009 13.9619C6.18718 13.9813 6.16083 14.0102 6.14443 14.0448C6.12361 14.0878 6.11282 14.1351 6.11285 14.1829C6.11324 14.2286 6.12404 14.2736 6.14443 14.3145C6.16336 14.3542 6.19297 14.388 6.22996 14.4119L6.4214 14.5237L6.37535 13.873ZM6.71877 14.0665L6.7339 14.2796L6.90627 14.179L6.71877 14.0665ZM6.71153 13.6796L7.23259 13.9901L9.24509 12.8244C9.27393 12.8073 9.29811 12.7833 9.31548 12.7546C9.32897 12.7331 9.33647 12.7083 9.33719 12.6829C9.33269 12.6032 9.29813 12.5282 9.24048 12.473C9.15166 12.3737 9.08785 12.3737 9.06745 12.3737C9.02994 12.3751 8.99297 12.3831 8.95824 12.3974C8.90003 12.4214 8.84391 12.4502 8.79048 12.4836L6.71153 13.6796Z" fill="#EA6404" ></path>
                                <path d="M10.9549 17.2788C10.8531 17.2738 10.7558 17.2349 10.6786 17.1682C10.634 17.1357 10.5978 17.0928 10.5732 17.0434C10.5486 16.9939 10.5362 16.9393 10.5372 16.884C10.5379 16.8181 10.5539 16.7533 10.5839 16.6946L13.7891 10.1321C13.8233 10.062 13.8753 10.0021 13.9398 9.95837C13.9974 9.91694 14.0662 9.894 14.1372 9.89258C14.2372 9.89676 14.3329 9.93454 14.4089 9.99982C14.4536 10.033 14.4896 10.0766 14.5137 10.1268C14.5377 10.177 14.5492 10.2323 14.547 10.288C14.5462 10.3539 14.5302 10.4187 14.5003 10.4774L11.3029 17.0399C11.2695 17.1091 11.2193 17.1688 11.1569 17.2136C11.0981 17.256 11.0274 17.2788 10.9549 17.2788Z" fill="#EA6404" ></path>
                                <path d="M10.9533 17.4419C10.8154 17.4371 10.6829 17.3864 10.577 17.2978C10.5125 17.2496 10.4603 17.1869 10.4245 17.1148C10.3887 17.0427 10.3704 16.9632 10.3711 16.8826C10.3724 16.791 10.3949 16.7009 10.4369 16.6195L13.6422 10.0609C13.6887 9.96447 13.76 9.88207 13.8487 9.82212C13.9489 9.75601 14.0681 9.725 14.1878 9.73393C14.3074 9.74285 14.4207 9.79123 14.5099 9.87146C14.5743 9.92043 14.6261 9.98393 14.6612 10.0568C14.6963 10.1296 14.7137 10.2097 14.7119 10.2905C14.7106 10.3822 14.6881 10.4723 14.6461 10.5537L11.4468 17.1123C11.4023 17.2069 11.3344 17.2887 11.2494 17.3498C11.1626 17.4103 11.0592 17.4425 10.9533 17.4419ZM14.1356 10.0603C14.0975 10.0609 14.0604 10.0733 14.0297 10.0958C13.9889 10.1234 13.9562 10.1613 13.9349 10.2057L10.7303 16.7649C10.7112 16.8012 10.7008 16.8416 10.7001 16.8826C10.6991 16.9129 10.7058 16.9429 10.7195 16.9699C10.7332 16.9969 10.7534 17.0201 10.7784 17.0373C10.8948 17.1267 10.9862 17.132 11.0606 17.0794C11.1008 17.0507 11.133 17.0122 11.154 16.9675L14.3507 10.4083C14.3697 10.3719 14.3801 10.3316 14.381 10.2905C14.383 10.26 14.3774 10.2295 14.3645 10.2018C14.3516 10.1741 14.3319 10.1501 14.3073 10.132C14.2592 10.0903 14.199 10.0652 14.1356 10.0603Z" fill="#EA6404" ></path>
                                <path d="M15.998 16.2202C15.9405 16.2175 15.8842 16.2023 15.8332 16.1756C15.7822 16.1489 15.7376 16.1113 15.7026 16.0656C15.6177 15.9806 15.5683 15.8665 15.5645 15.7465C15.5638 15.6908 15.5789 15.6361 15.6079 15.5886C15.6415 15.5368 15.6865 15.4934 15.7395 15.4616L18.4789 13.8748L18.5342 14.6642L15.748 12.9978C15.6911 12.9662 15.6452 12.918 15.6164 12.8596C15.5907 12.807 15.5772 12.7492 15.577 12.6906C15.5755 12.5659 15.6227 12.4455 15.7086 12.355C15.7398 12.3137 15.7793 12.2793 15.8247 12.2541C15.87 12.229 15.9201 12.2136 15.9717 12.209C16.0368 12.2107 16.1005 12.2283 16.1572 12.2603C16.2226 12.2945 16.2923 12.3327 16.3664 12.3748L18.9322 13.8827C18.9939 13.9184 19.0434 13.9718 19.0743 14.036C19.1055 14.1014 19.1217 14.173 19.1217 14.2455C19.1217 14.318 19.1055 14.3896 19.0743 14.455C19.0436 14.5195 18.9941 14.5732 18.9322 14.609L16.3664 16.0853C16.3007 16.1221 16.2349 16.1511 16.177 16.18C16.121 16.2065 16.0599 16.2202 15.998 16.2202Z" fill="#EA6404" ></path>
                                <path d="M15.9985 16.3842C15.9178 16.3818 15.8386 16.3619 15.7663 16.3259C15.6941 16.2899 15.6305 16.2387 15.58 16.1757C15.468 16.0603 15.4039 15.9068 15.4004 15.7461C15.3993 15.6604 15.4221 15.5761 15.4662 15.5026C15.5124 15.43 15.5745 15.3688 15.6478 15.3237L17.5096 14.2447L15.6603 13.1395C15.5746 13.0919 15.5057 13.0191 15.4629 12.9309C15.4265 12.8561 15.4074 12.774 15.407 12.6908C15.4063 12.5245 15.47 12.3645 15.5846 12.2441C15.6572 12.1469 15.7631 12.08 15.8821 12.0563C16.001 12.0326 16.1245 12.0538 16.2287 12.1158C16.2945 12.1493 16.3669 12.1888 16.4432 12.2322L19.009 13.7408C19.099 13.7928 19.1712 13.8708 19.2162 13.9645C19.2588 14.0523 19.2812 14.1485 19.282 14.2461C19.2814 14.3432 19.2589 14.439 19.2162 14.5263C19.1714 14.6209 19.0986 14.6994 19.0077 14.7513L16.4471 16.2283C16.3715 16.2691 16.305 16.3026 16.2439 16.3303C16.167 16.3661 16.0832 16.3845 15.9985 16.3842ZM17.8333 14.4382L15.8208 15.6039C15.792 15.6218 15.7673 15.6455 15.7485 15.6737C15.7352 15.6955 15.7286 15.7206 15.7294 15.7461C15.7335 15.8254 15.7676 15.9001 15.8248 15.9553C15.9142 16.0553 15.9781 16.0553 15.9985 16.0553C16.0351 16.055 16.0713 16.0467 16.1044 16.0309C16.159 16.0059 16.2189 15.9763 16.2833 15.9408L18.355 14.7493L17.8333 14.4382ZM18.6445 13.9072L18.6906 14.5559L18.8458 14.4664C18.8794 14.4475 18.9061 14.4185 18.9221 14.3836C18.9427 14.3404 18.9534 14.2932 18.9534 14.2454C18.9534 14.1976 18.9427 14.1504 18.9221 14.1072C18.906 14.0726 18.8793 14.044 18.8458 14.0257L18.6445 13.9072ZM18.1596 14.2493L18.3471 14.3618L18.332 14.1487L18.1596 14.2493ZM15.9669 12.3737C15.9109 12.3875 15.8615 12.4205 15.8274 12.4671C15.7982 12.4965 15.7752 12.5314 15.7596 12.5698C15.744 12.6082 15.7362 12.6494 15.7366 12.6908C15.737 12.725 15.7451 12.7588 15.7603 12.7895C15.7753 12.8173 15.7982 12.8402 15.8261 12.8553L17.8333 14.0559L18.3682 13.7461L16.2761 12.5164C16.2057 12.4757 16.1379 12.4395 16.0741 12.4059C16.0413 12.387 16.0046 12.376 15.9669 12.3737Z" fill="#EA6404" ></path>
                            </svg>
                            </div>
                            <div className="file-text">
                            <span className="ext-name">Login.html</span>
                            <strong>
                                <span className="date-name">01/09/2022</span>
                                <span className="file-size">7.5 mb</span>
                            </strong>
                            </div>
                        </div>
                        <div className="file-actions flex-center">
                            <button className="download-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                                <path d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z" fill="#6D7080" ></path>
                            </svg>
                            </button>
                            <button className="delete-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" >
                                <path d="M8.20039 3.80078H11.8004C11.8004 3.32339 11.6107 2.86555 11.2732 2.52799C10.9356 2.19042 10.4778 2.00078 10.0004 2.00078C9.523 2.00078 9.06516 2.19042 8.7276 2.52799C8.39003 2.86555 8.20039 3.32339 8.20039 3.80078ZM7.00039 3.80078C7.00039 3.00513 7.31646 2.24207 7.87907 1.67946C8.44168 1.11685 9.20474 0.800781 10.0004 0.800781C10.796 0.800781 11.5591 1.11685 12.1217 1.67946C12.6843 2.24207 13.0004 3.00513 13.0004 3.80078H19.0004C19.1595 3.80078 19.3121 3.864 19.4247 3.97652C19.5372 4.08904 19.6004 4.24165 19.6004 4.40078C19.6004 4.55991 19.5372 4.71252 19.4247 4.82505C19.3121 4.93757 19.1595 5.00078 19.0004 5.00078H17.7356L16.3028 17.4136C16.2015 18.291 15.7812 19.1006 15.1218 19.6883C14.4625 20.2759 13.61 20.6007 12.7268 20.6008H7.27399C6.39074 20.6007 5.53833 20.2759 4.87895 19.6883C4.21958 19.1006 3.79927 18.291 3.69799 17.4136L2.26519 5.00078H1.00039C0.841261 5.00078 0.688648 4.93757 0.576127 4.82505C0.463605 4.71252 0.400391 4.55991 0.400391 4.40078C0.400391 4.24165 0.463605 4.08904 0.576127 3.97652C0.688648 3.864 0.841261 3.80078 1.00039 3.80078H7.00039ZM4.88959 17.2768C4.9573 17.8617 5.23765 18.4012 5.67729 18.7929C6.11694 19.1845 6.68521 19.4009 7.27399 19.4008H12.7268C13.3156 19.4009 13.8838 19.1845 14.3235 18.7929C14.7631 18.4012 15.0435 17.8617 15.1112 17.2768L16.5272 5.00078H3.47359L4.88959 17.2768ZM8.20039 8.00078C8.35952 8.00078 8.51213 8.06399 8.62466 8.17652C8.73718 8.28904 8.80039 8.44165 8.80039 8.60078V15.8008C8.80039 15.9599 8.73718 16.1125 8.62466 16.225C8.51213 16.3376 8.35952 16.4008 8.20039 16.4008C8.04126 16.4008 7.88865 16.3376 7.77613 16.225C7.6636 16.1125 7.60039 15.9599 7.60039 15.8008V8.60078C7.60039 8.44165 7.6636 8.28904 7.77613 8.17652C7.88865 8.06399 8.04126 8.00078 8.20039 8.00078ZM12.4004 8.60078C12.4004 8.44165 12.3372 8.28904 12.2247 8.17652C12.1121 8.06399 11.9595 8.00078 11.8004 8.00078C11.6413 8.00078 11.4886 8.06399 11.3761 8.17652C11.2636 8.28904 11.2004 8.44165 11.2004 8.60078V15.8008C11.2004 15.9599 11.2636 16.1125 11.3761 16.225C11.4886 16.3376 11.6413 16.4008 11.8004 16.4008C11.9595 16.4008 12.1121 16.3376 12.2247 16.225C12.3372 16.1125 12.4004 15.9599 12.4004 15.8008V8.60078Z" fill="#6D7080" ></path>
                            </svg>
                            </button>
                        </div>
                        </div>

                        <div className="uploading-file-list flex">
                        <div className="left-file-desc flex-center">
                            <div className="icon-block">
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none" >
                                <path d="M12.375 17.875H20.625M12.375 23.375H16.5M5.5 5.5V27.5C5.5 28.2293 5.78973 28.9288 6.30546 29.4445C6.82118 29.9603 7.52065 30.25 8.25 30.25H24.75C25.4793 30.25 26.1788 29.9603 26.6945 29.4445C27.2103 28.9288 27.5 28.2293 27.5 27.5V11.4703C27.5 11.1039 27.4267 10.7412 27.2846 10.4036C27.1424 10.0659 26.9342 9.76008 26.6723 9.504L20.5673 3.53375C20.0535 3.0314 19.3635 2.75009 18.645 2.75H8.25C7.52065 2.75 6.82118 3.03973 6.30546 3.55546C5.78973 4.07118 5.5 4.77065 5.5 5.5V5.5Z" stroke="#2C8D94" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ></path>
                                <path d="M19.25 2.75V8.25C19.25 8.97935 19.5397 9.67882 20.0555 10.1945C20.5712 10.7103 21.2707 11 22 11H27.5" stroke="#2C8D94" strokeWidth="2" strokeLinejoin="round" ></path>
                            </svg>
                            </div>
                            <div className="file-text">
                            <span className="ext-name">Task.doc</span>
                            <strong>
                                <span className="date-name">01/09/2022</span>
                                <span className="file-size">7.5 mb</span>
                            </strong>
                            </div>
                        </div>
                        <div className="file-actions flex-center">
                            <button className="download-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none" >
                                <path d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z" fill="#6D7080" ></path>
                            </svg>
                            </button>
                            <button className="delete-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" >
                                <path d="M8.20039 3.80078H11.8004C11.8004 3.32339 11.6107 2.86555 11.2732 2.52799C10.9356 2.19042 10.4778 2.00078 10.0004 2.00078C9.523 2.00078 9.06516 2.19042 8.7276 2.52799C8.39003 2.86555 8.20039 3.32339 8.20039 3.80078ZM7.00039 3.80078C7.00039 3.00513 7.31646 2.24207 7.87907 1.67946C8.44168 1.11685 9.20474 0.800781 10.0004 0.800781C10.796 0.800781 11.5591 1.11685 12.1217 1.67946C12.6843 2.24207 13.0004 3.00513 13.0004 3.80078H19.0004C19.1595 3.80078 19.3121 3.864 19.4247 3.97652C19.5372 4.08904 19.6004 4.24165 19.6004 4.40078C19.6004 4.55991 19.5372 4.71252 19.4247 4.82505C19.3121 4.93757 19.1595 5.00078 19.0004 5.00078H17.7356L16.3028 17.4136C16.2015 18.291 15.7812 19.1006 15.1218 19.6883C14.4625 20.2759 13.61 20.6007 12.7268 20.6008H7.27399C6.39074 20.6007 5.53833 20.2759 4.87895 19.6883C4.21958 19.1006 3.79927 18.291 3.69799 17.4136L2.26519 5.00078H1.00039C0.841261 5.00078 0.688648 4.93757 0.576127 4.82505C0.463605 4.71252 0.400391 4.55991 0.400391 4.40078C0.400391 4.24165 0.463605 4.08904 0.576127 3.97652C0.688648 3.864 0.841261 3.80078 1.00039 3.80078H7.00039ZM4.88959 17.2768C4.9573 17.8617 5.23765 18.4012 5.67729 18.7929C6.11694 19.1845 6.68521 19.4009 7.27399 19.4008H12.7268C13.3156 19.4009 13.8838 19.1845 14.3235 18.7929C14.7631 18.4012 15.0435 17.8617 15.1112 17.2768L16.5272 5.00078H3.47359L4.88959 17.2768ZM8.20039 8.00078C8.35952 8.00078 8.51213 8.06399 8.62466 8.17652C8.73718 8.28904 8.80039 8.44165 8.80039 8.60078V15.8008C8.80039 15.9599 8.73718 16.1125 8.62466 16.225C8.51213 16.3376 8.35952 16.4008 8.20039 16.4008C8.04126 16.4008 7.88865 16.3376 7.77613 16.225C7.6636 16.1125 7.60039 15.9599 7.60039 15.8008V8.60078C7.60039 8.44165 7.6636 8.28904 7.77613 8.17652C7.88865 8.06399 8.04126 8.00078 8.20039 8.00078ZM12.4004 8.60078C12.4004 8.44165 12.3372 8.28904 12.2247 8.17652C12.1121 8.06399 11.9595 8.00078 11.8004 8.00078C11.6413 8.00078 11.4886 8.06399 11.3761 8.17652C11.2636 8.28904 11.2004 8.44165 11.2004 8.60078V15.8008C11.2004 15.9599 11.2636 16.1125 11.3761 16.225C11.4886 16.3376 11.6413 16.4008 11.8004 16.4008C11.9595 16.4008 12.1121 16.3376 12.2247 16.225C12.3372 16.1125 12.4004 15.9599 12.4004 15.8008V8.60078Z" fill="#6D7080" ></path>
                            </svg>
                            </button>
                        </div>
                        </div>
                    </div> */}
                    </div>
                    : '' : ''
                     }
                 {uiFeatures.CHANGE_TARGET_LANGUAGES && projectResource.projectContentType !== "post" && projectResource.projectContentType !== "page" ?
                    <div className="wrap-dropdown target-content">
                    <h5>{translate("change_order.chnage_target_language")}</h5>
                    {targetLanguages.length > 0 ?
                    (targetLanguages.length === 1 && targetLanguages[0].value === 'all') ?
                    <strong>All available target languages are already being used for this project</strong> :
                    <div className="global-dropdown-block flex-center mar-bot10">
                        <label>{translate("change_order.add_new_language")}</label>
                        <div className="global-dropdown-select">
                        <Select classNamePrefix='cw' className="global-dropdown-select"
                            value={targetLanguages.filter(function (option) {
                            return option.code === selectedLanguages;
                            })}
                            aria-label="Add New Language" 
                            options={targetLanguages}
                            onChange={(e) => handleLanguageChange(e)}
                        />
                        </div>
                        </div>
                         : ''}
                       
                   {(!noLanguageIsRemovable && hasNotRemovableLanguage) ? 
                    <div className='flex align-items'>
                        <strong>Click on a language below to remove</strong>
                        <button
                              aria-label="tooltip"
                              className="pl-10"
                              data-tip
                              data-place="right"
                              data-for={`file-removed-reason`}
                            >
                              <svg
                               style={{marginBottom:"-3px"}}
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
                                  fill="#64748B"
                                ></path>
                                <path
                                  d="M8.92995 6.588L6.63995 6.875L6.55795 7.255L7.00795 7.338C7.30195 7.408 7.35995 7.514 7.29595 7.807L6.55795 11.275C6.36395 12.172 6.66295 12.594 7.36595 12.594C7.91095 12.594 8.54395 12.342 8.83095 11.996L8.91895 11.58C8.71895 11.756 8.42695 11.826 8.23295 11.826C7.95795 11.826 7.85795 11.633 7.92895 11.293L8.92995 6.588ZM8.99995 4.5C8.99995 4.76522 8.8946 5.01957 8.70706 5.20711C8.51952 5.39464 8.26517 5.5 7.99995 5.5C7.73474 5.5 7.48038 5.39464 7.29285 5.20711C7.10531 5.01957 6.99995 4.76522 6.99995 4.5C6.99995 4.23478 7.10531 3.98043 7.29285 3.79289C7.48038 3.60536 7.73474 3.5 7.99995 3.5C8.26517 3.5 8.51952 3.60536 8.70706 3.79289C8.8946 3.98043 8.99995 4.23478 8.99995 4.5Z"
                                  fill="#64748B"
                                ></path>
                              </svg>
                            </button>
                            <Tooltip className="extraClass" id={`file-removed-reason`} delayHide={500} effect="solid" >
                              <div className="react-innerTooltip">
                                {Constants.CHANGE_ORDER_REMOVE_LANG_TOOLTIP}
                              </div>
                            </Tooltip>
                    </div> :''  
                   }
                    <div className='flex align-items'>
                        {selectedDisplayLangs.length > 0 ? 
                        <>
                        <p className='mr-12 font12'>{translate("change_order.target_language")}</p>
                        <div className="multiselect-output flex">
                        {selectedDisplayLangs.map((selected, index) => {
                            return (
                             <div key={index}> 
                            <button  data-tip data-place="top" data-for={`file-removed-reason-${languageApproved(selected)}`}
                            title={languageApproved(selected) === selected.value ? notRemovableReason : 'removable'}
                               disabled={languageApproved(selected) === selected.value} 
                               onClick={() => removeItem(selected)} aria-label={"remove " + selected.label}>
                                <strong>{selected.label}</strong>
                                {!( languageApproved(selected)) ?
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none" >
                                <path d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067" stroke="#213248" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" ></path>
                                </svg>
                                :''}
                            </button>
                          </div>  
                            );
                        })}
                        </div>
                        </>
                        :
                        <p className='error'>{Constants.CHANGE_ORDER_NO_TARGET_LANGUAGE_SELECTED}</p> 
                        }
                    </div>
                    </div>
                    : 
                    <div className="wrap-dropdown target-content">
                    <h5>{translate("change_order.chnage_target_language")}</h5>
                    <div className='flex align-items'>
                            <p>{Constants.CHANGE_ORDER_TARGET_LANGUAGE_UI_FEATURES}</p>{" "}
                    </div>
                    </div> }

                    <div className="select-workflow project-tab-workflow">
                    {newSelectedLangs && newSelectedLangs !=="" && newSelectedLangs?.length !== 0 ?
                    <div className="title">
                        <h5>{translate("change_order.dates_assignees")} {updatedWorkflow[0]?.templateName}</h5>
                        <p>
                  {translate("change_order.setup_reviewers")}
                        </p>
                        <span className="blue">How does this work?</span>
                    </div>: Constants.BLANK}
                    {validationError[""] !== '' ? <p className='error'>{validationError[""]}</p> : ''}
                    {validationError["wf.workflowLanguage.sizeMismatch"] !== "" ? <p className='error'>{validationError["wf.workflowLanguage.sizeMismatch"]}</p> : ''}
                    {newSelectedLangs && newSelectedLangs !=="" && newSelectedLangs?.length ? newSelectedLangs?.map((newlang, langIndex) => {
                            return (
                            <div key={langIndex}>
                                <h6>{newlang?.displayName[0]?.display}</h6>
                                <div className="workflow-wrap clearfix">
                                {newlang.resource.steps.map((step, stepIndex) => {
                                    return (
                                        <div className="workflow-step-list open-step" key={stepIndex}>
                                    <div className="inner-step-list">
                                    <button className="step-btn">
                                        <i className="plus-icon"></i>
                                        {step.name}
                                    </button>
                                    <div className="workflow-step-content flex">
                                            {step.phases.map((phase,phaseIndex)=>{
                                            return (
                                                <div className="step-box-list" id={phase.phaseType.display + "-phase-" +phase.phaseNumber} key={phaseIndex}>
                                                {setDurationInDays(step,phase,phase.phaseNumber,step.stepNumber,newlang.resource,langIndex,newlang)}
                                                {setPhaseType(step, phase)}
                                                <strong>
                                                    {phase.assigneeType.display}
                                                </strong>
                                                {phase.assigneeType.display !=="Vendor" && (
                                                    <div className="step-assignee">
                                                        <div className="step-assignee flex-center assignHidepopup" tabIndex="0" 
                                                        style={validationError[`wf.phaseAssignee.${newlang.displayName[0].code}_${step.stepNumber}_${phase.phaseNumber}`] === 'Assignee required'
                                                              ? {border:"2px solid #A61616",padding:"0px 2px",borderRadius:"5px"}
                                                              : null
                                                          }
                                                            onClick={(e) => selectAssignee(`assignee-list-${langIndex +"-" +stepIndex +"-" +phaseIndex}`,e,phase.allowMultiAssignee)}
                                                        role="button"aria-label="Single Assignee"aria-expanded={assigneeListExpanded}>
                                                            {phase.allowMultiAssignee ? ActiveMultiAssigneeIcon :ActiveAssigneeManIcon
                                                        }
                                                        {setAssigneeValue(newlang.resource,stepIndex,phaseIndex,langIndex)}
                                                        <svg data-stepnum={step.stepNumber} data-phasenum={phase.phaseNumber} className="download-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8ZM16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM8.5 4.5C8.5 4.36739 8.44732 4.24021 8.35355 4.14645C8.25979 4.05268 8.13261 4 8 4C7.86739 4 7.74021 4.05268 7.64645 4.14645C7.55268 4.24021 7.5 4.36739 7.5 4.5V10.293L5.354 8.146C5.26011 8.05211 5.13278 7.99937 5 7.99937C4.86722 7.99937 4.73989 8.05211 4.646 8.146C4.55211 8.23989 4.49937 8.36722 4.49937 8.5C4.49937 8.63278 4.55211 8.76011 4.646 8.854L7.646 11.854C7.69245 11.9006 7.74762 11.9375 7.80837 11.9627C7.86911 11.9879 7.93423 12.0009 8 12.0009C8.06577 12.0009 8.13089 11.9879 8.19163 11.9627C8.25238 11.9375 8.30755 11.9006 8.354 11.854L11.354 8.854C11.4479 8.76011 11.5006 8.63278 11.5006 8.5C11.5006 8.36722 11.4479 8.23989 11.354 8.146C11.2601 8.05211 11.1328 7.99937 11 7.99937C10.8672 7.99937 10.7399 8.05211 10.646 8.146L8.5 10.293V4.5Z" fill="#1D4ED8" />
                                                        </svg>
                                                        </div>
                                                        <div className={showAssigneeList ===`assignee-list-${langIndex +"-" +stepIndex +"-" +phaseIndex}`
                                                            ? `popover-body show assignee-list-${langIndex +"-" +stepIndex +"-" +phaseIndex}`
                                                            : `popover-body assignee-list-${langIndex +"-" +stepIndex +"-" +phaseIndex}`} style={{top:"15px",zIndex:"10"}}>
                                                            <div className="triangle-with-shadow"></div>
                                                            <div className="inner-popover" role="radiogroup" aria-label="Choose Assignee">
                                                            <h4>Choose Assignee</h4>
                                                                {phase.phaseType.display === "Review" ? 
                                                                            <EditAssigneeComponent 
                                                                            langIndex={langIndex}
                                                                            stepIndex={stepIndex}
                                                                            phaseIndex={phaseIndex}
                                                                            step={step}
                                                                            phase={phase}
                                                                            newlang={newlang}
                                                                            />
                                                                : 
                                                                <div className="group-radio-list"> {
                                                                    workAssigneeList.map((element,workAsigneeIndex) => {
                                                                        if(projectResource?.projectVendorType === "EXTERNAL") {
                                                                            return (
                                                                                <EditAssigneeComponent 
                                                                                    langIndex={langIndex}
                                                                                    stepIndex={stepIndex}
                                                                                    phaseIndex={phaseIndex}
                                                                                    step={step}
                                                                                    phase={phase}
                                                                                    newlang={newlang}
                                                                            />
                                                                            );
                                                                        } else {
                                                                            return (
                                                                                <div className="radio-form-check" key={workAsigneeIndex}>
                                                                                <input aria-label={element?.customerUser?.firstName +" " +element?.customerUser?.lastName}
                                                                                type="checkbox" className="form-check-input"
                                                                                name={element?.customerUser?.firstName + " " + element?.customerUser?.lastName}
                                                                                id={`${langIndex +"-" +stepIndex +"-" +phaseIndex}-`+element?.customerUser?.userId}
                                                                                value={element?.customerUser?.firstName +" " +element?.customerUser?.lastName}
                                                                                checked={phase.assigneeUsers[0]?.userId === element?.customerUser.userId}
                                                                                onKeyDown={(event) => onValueChange(event,element,phase,phase.phaseNumber,step.stepNumber,newlang.resource,langIndex,phase.allowMultiAssignee)}    
                                                                                onChange={(event) => onValueChange(event,element,phase,phase.phaseNumber,step.stepNumber,newlang.resource,langIndex,phase.allowMultiAssignee)}
                                                                                />
                                                                                <label
                                                                                className="form-check-label"
                                                                                htmlFor={`${langIndex +"-" +stepIndex +"-" +phaseIndex}-`+element?.customerUser?.userId}>
                                                                                {element?.customerUser?.firstName +" " +element?.customerUser?.lastName}
                                                                                </label>
                                                                            </div>
                                                                            );
                                                                        }
                                                                    }
                                                                    )
                                                                    }
                                                            </div>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="step-request">
                                                    <div className="left-icon">
                                                    {!phase.allowRevision && (
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12" fill="none">
                                                        <path d="M13.5303 6.53033C13.8232 6.23744 13.8232 5.76256 13.5303 5.46967L8.75736 0.696699C8.46447 0.403806 7.98959 0.403806 7.6967 0.696699C7.40381 0.989593 7.40381 1.46447 7.6967 1.75736L11.9393 6L7.6967 10.2426C7.40381 10.5355 7.40381 11.0104 7.6967 11.3033C7.98959 11.5962 8.46447 11.5962 8.75736 11.3033L13.5303 6.53033ZM0 6.75H13V5.25H0V6.75Z" fill="#97A2AC" />
                                                        </svg>
                                                    )}
                                                    {phase.allowRevision && (
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width="30" height="23" >
                                                        <path d="M 22 12 C 16.486 12 12 16.486 12 22 L 12 23 C 12 24.104 12.896 25 14 25 C 15.104 25 16 24.104 
                                                                                    16 23 L 16 22 C 16 18.691 18.691 16 22 16 L 42 16 C 45.309 16 48 18.691 48 22 L 48 24 L 45.107422 24 C 
                                                                                    44.213422 24 43.685313 25.003281 44.195312 25.738281 L 49.089844 32.8125 C 49.529844 33.4495 50.471109 
                                                                                    33.4495 50.912109 32.8125 L 55.806641 25.738281 C 56.314641 25.003281 55.788531 24 54.894531 24 L 52 24 L 
                                                                                    52 22 C 52 16.486 47.514 12 42 12 L 22 12 z M 14 30.708984 C 13.654375 30.708984 13.308391 30.869 13.087891 
                                                                                    31.1875 L 8.1953125 38.261719 C 7.6873125 38.996719 8.2134219 40 9.1074219 40 L 12 40 L 12 42 C 12 47.514 
                                                                                    16.486 52 22 52 L 42 52 C 47.514 52 52 47.514 52 42 L 52 41 C 52 39.896 51.104 39 50 39 C 48.896 39 48 
                                                                                    39.896 48 41 L 48 42 C 48 45.309 45.309 48 42 48 L 22 48 C 18.691 48 16 45.309 16 42 L 16 40 L 18.892578 
                                                                                    40 C 19.786578 40 20.314688 38.996719 19.804688 38.261719 L 14.910156 31.1875 C 14.690156 30.869 14.345625 
                                                                                    30.708984 14 30.708984 z" fill="#97A2AC"
                                                        />
                                                        </svg>
                                                    )}
                                                    </div>
                                                    <span className={phase.allowRevision? "revision-allowed": "revision-disallowed"}>
                                                    {phase.allowRevision? "Can Request Revision": "Cannot Request Revision"}
                                                    </span>
                                                </div>
                                                </div>
                                            );
                                            })}
                                            
                                       
                                    </div>
                                    </div>
                                    </div>)
                                     }
                                     )}
                               
                                </div>
                            </div>
                            );
                        })
                        : null}
                    </div>
                </div>
                {(options.accountStatus !== undefined && options.accountStatus.verified && options.permissions.BID_AUTO_APPROVAL && projectResource.projectVendorType !== "INTERNAL") ? 
                    <div className='align-items'>
                        <strong>Change Order Quote</strong>
                        <p>Select the option below to have the quote submitted by the vendor automatically approved.</p>
                        <div className="form-check-outer">
                        <div className="form-check small-checkbox">
                            <input
                            type="checkbox"
                            id="autoBid"
                             checked={autoBid}
                            onChange={checkAutoBid}
                            />
                            <label htmlFor="autoBid">{`Yes - automatically approve the quote submitted by ${projectResource.vendor.name}`}</label>
                        </div>
                    </div>
                    </div> :'' 
                   }
            </div>
            <div className="stricy-btn flex flex-center no-rightlist">
                <div className="left flex">
                    <div>
                    <button className="btn-default" aria-label="Cancel"
                    onClick={() => setShowCreateChangeOrder(false)}>Cancel</button>
                    </div>
                </div>
                <div className="left flex">
                    <div>
                    <button 
                    disabled={!orderName.length || buttonDisabled || selectedDisplayLangs.length === 0} className={!orderName.length ?'btn disabled-data':'btn changeOrder'} aria-label="Submit Change Order" 
                    onClick={confirmSubmit}>
                        Submit Change Order{" "}
                        {changeOrderCreating ? (
                          <div style={{display:"inline"}}>
                            <RotatingLines
                              strokeColor="#d6d9df"
                              strokeWidth="5"
                              animationDuration="0.75"
                              width="16"
                              visible={true}
                            />
                          </div>
                        ) : ''}
                    </button>
                    </div>
                </div>
            </div>
        </>
    );
}
